/* eslint-disable  @nice-cxone/ccf/required-tsdoc*/
import {
  Grid,
  Card,
  Paper,
  CardActionArea,
  CardActions,
  Button,
  CardContent,
  Typography,
  CardHeader,
  Avatar,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Slide,
  Theme,
  Divider,
  FormControlLabel,
  Switch,
  Box,
  Checkbox,
  InputAdornment,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormGroup,
} from '@mui/material';

import { makeStyles, createStyles } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux';
import { DigitalChannelType, MediaType } from '@nice-ccf/core-sdk';
import dayjs, { Dayjs, locale } from 'dayjs';
import { TransitionGroup } from 'react-transition-group';
import {
  Contact,
  contactState,
  updateselectedContactHistory,
  contactSelectedIndexState,
  updateContactSelection,
  modalMessageState,
  updateselectedContact,
  CustomerHistory,
  updateselectedAgentHistory,
  ExpertSystemOptions,
  getExpertSystemOptions,
  updateExpertSystemOptions,
  updateselectedInteractionHistory,
  updateselectedCustomer,
  clearAllSimulatorData,
} from './simulator.slice';
import classes from './simulator.module.scss';
import { BroadcastChannel } from 'broadcast-channel';
import { Helmet } from 'react-helmet';
import React, { useEffect, useRef, useState } from 'react';
import {
  CcfAccordion,
  CcfAccordionDetails,
  CcfAccordionSummary,
  CcfAlert,
  CcfBox,
  CcfButton,
  CcfChatIcon,
  CcfDoubleArrowIcon,
  CcfSimulatorUploadIcon,
  CcfSnackBar,
  CcfTypography,
  CcfCloseIcon,
  CcfTextField,
  CcfUpArrowIcon,
  CcfCalendarIcon,
  CcfEditIcon,
  CcfTooltip,
  DividerOrientation,
  DividerVariant,
  CcfDivider,
  CcfDatePickerIcon,
} from '@nice-ccf/ui-controls';
import simulatorStyles from './simulator.styles';
import axios from 'axios';
//import CcfEmailProgressBar from 'libs/react/ui-components/src/lib/ccf-digital-email-template/ccf-email-progress-bar';
import { useTheme } from '@mui/material';
import {
  CcfEmailProgressBar,
  contactHistory,
  getCopilotConfig,
  getIsLiveCopilotEnabled,
  setIsLiveCopilotEnabled,
  getApplicationLocale,
  globalActions,
} from '@nice-ccf/ui-components';
import 'react-datepicker/dist/react-datepicker.css';
import ContactHistoryCard from './contact-history-card/contact-history-card';
import { generateRandomId, processResultToArray } from './simulator-util';
import CurrentInteraction from './current-interaction/current-interaction';
import {
  API_BASE_URL,
  AUTHORIZATION_TOKEN,
  callApi,
  EXPERT_VERTICALS,
  PERSONA,
  PROCESS_UTTERANCE,
} from 'libs/react/ui-components/src/lib/ccf-app-space/ccf-copilot/ccf-copilot-api';
import { v5 as uuidv5, NIL as namespaceNIL } from 'uuid';
import InteractionsHistoryCard from './interactions-history-card/interactions-history-card';
import Carousel from 'react-material-ui-carousel';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AgentVoiceSimulator } from './agentVoiceSimulator';
import { useMsal } from '@azure/msal-react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minHeight: '45px',
      margin: '0',
      '&$expanded': {
        minHeight: '45px',
        margin: '0',
      },
    },
    content: {
      margin: '0',
      '&$expanded': {
        margin: '0',
      },
    },
    expanded: {
      margin: '0',
    },
  })
);

/**
 * Simulator Component to mimic the Call/Post feature from different sources
 */
export function Simulator() {
  //#region Variable region
  const dispatch = useDispatch();
  const contact: Contact[] = useSelector(contactState);
  const selectedContactIndex: number = useSelector(contactSelectedIndexState);
  const modalMessage: string = useSelector(modalMessageState);
  const selectedContact: Contact = contact[selectedContactIndex];
  const buttonText = selectedContact.media === 'Voice' ? 'Call' : 'Post';
  const [showToast, setShowToast] = useState(false);
  const [openClearSimulator, setOpenClearSimulator] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [clearSimulatorClicked, setClearSimulatorClicked] = useState(false);

  const isLiveCopilotEnabled = useSelector(getIsLiveCopilotEnabled);
  const copilotConfigurationData = useSelector(getCopilotConfig);
  const locale = copilotConfigurationData?.language;
  const expertSystemOptions = useSelector(getExpertSystemOptions);
  const namespace = uuidv5('namespace', namespaceNIL);
  const isTestEnvironment =
    window.location.hostname === 'd1s74gzjhz7gu0.cloudfront.net';

  //#endregion

  //#region method region
  /**
   * Used to handle the current contact being selected from the ListCard component
   * @param userIndex - current userIndex
   */
  const handleUserSelection = (userIndex: number) => {
    handleCopilotToggle(false); //Disable Live Copilot simulator View by default on each contact selection
    dispatch(updateselectedContact({ field: 'copilotSource', value: 'JSON' })); //always Update CopilotSource to JSON by default on each contact selection
    dispatch(updateContactSelection(userIndex));
    handleCopilotToggle(false); //Disable Live Copilot simulator View by default on each contact selection
    dispatch(updateselectedContact({ field: 'copilotSource', value: 'JSON' })); //always Update CopilotSource to JSON by default on each contact selection
    dispatch(updateselectedContact({ field: 'liveVoice', value: 'No' }));
  };

  useEffect(() => {
    if (
      selectedContact.channel === 'Chat' &&
      selectedContact?.customerChatReply !== ''
    ) {
      broadCastMessage();
    }
  }, [selectedContact?.customerChatReply]);

  /**
   * Used to broadcast the message through 'simulator_channel' using broadcast channel
   */
  const broadCastMessage = async () => {
    let selectedContactCopy = { ...selectedContact };
    selectedContactCopy = { ...selectedContactCopy, dateCreated: new Date() };

    if (selectedContactCopy.channel === 'Email') {
      if (!validateEmail(selectedContactCopy.customer.emailId)) {
        setToastMessage('Entered Email is Invaild');
        setShowToast(true);
      } else {
        const channel: BroadcastChannel<{ type: string; data: Contact }> =
          new BroadcastChannel('simulator_channel');
        await channel.postMessage({
          type: 'insertContact',
          data: selectedContactCopy,
        });
        await channel.close();
        setToastMessage('Your ' + buttonText + ' was successful');
        setShowToast(true);
      }
    } else {
      const channel: BroadcastChannel<{ type: string; data: Contact }> =
        new BroadcastChannel('simulator_channel');
      await channel.postMessage({
        type: 'insertContact',
        data: selectedContactCopy,
      });
      await channel.close();
      setToastMessage('Your ' + buttonText + ' was successful');
      setShowToast(true);
    }
  };

  /**
   * Used to validateEmail
   * @param email - input field values
   */
  const validateEmail = (email: string) => {
    const reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    if (reg.test(email) === false) {
      setToastMessage('Entered Email is Invaild');
      setShowToast(true);
      return false;
    }
    return true;
  };

  /**
   * Used to close the snackbar
   * @param event -React.SyntheticEvent
   * @param reason -string
   */
  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setShowToast(false);
  };

  /**
   * Used to handle the Form Input change event and update the contact card values
   * @param field - input field name
   * @param value - input field values
   */
  const handleInputChange = (field: string, value: any) => {
    dispatch(updateselectedContact({ field, value }));
    if (field === 'copilotSource') {
      if (value === 'Live LLM') {
        handleCopilotToggle(true);
        if (selectedContact?.botTranscript) {
          dispatch(
            updateselectedContact({ field: 'botTranscript', value: false })
          );
        }
      } else {
        handleCopilotToggle(false);
        dispatch(
          updateselectedContact({
            field: 'customerChatReplyJsonData',
            value: [],
          })
        );
        handleInputChange('liveVoice', 'No');
      }
    }
    if (field === 'liveVoice') {
      const id = generateRandomId('agentName', 'CustomerName');
      handleInputChange('id', id.toString());
    }
    //  else {
    //   dispatch(
    //     updateselectedContact({ field: 'copilotSource', value: 'JSON' })
    //   );
    //   // handleCopilotToggle(false);
    // }
  };

  /**
   * Used to broadcast the message through 'simulator_channel' using broadcast channel
   */
  const broadCastCopilotData = (chatMessage: string) => {
    const requestBody = {
      // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
      contactId: contact[selectedContactIndex]?.id,
      busNo: 12345678,
      tenantId: '12345678',
      participantId: 'patron',
      messageBody: chatMessage,
      getSalesOffers: false,
      getCompliance: false,
      getKbCombo: false,
      getProcessSteps: false,
      getConversationAssistance: false,
      messageMetaData: {
        completeUtterance: true,
      },
      transcriptionEventId: uuidv5(chatMessage, namespace),
      threshold_sales: copilotConfigurationData?.threshold_sales ?? 0.75,
      threshold_compliance:
        copilotConfigurationData?.threshold_compliance ?? 0.75,
      agentAssistAppConfig: {
        language: locale?.toLowerCase(),
        generativeResponseTone:
          copilotConfigurationData?.generativeResponseTone ?? 'Formal',
        channels: ['digital', 'voice'],
        transcriptionProfileName: 'google-test',
        enableSentiment: copilotConfigurationData?.enableSentiment ?? true,
        sentimentResponseLength:
          copilotConfigurationData?.sentimentResponseLength ?? 20,
        realTimeSummary: copilotConfigurationData?.realTimeSummary ?? true,
        realTimeSummaryResponseLength:
          copilotConfigurationData?.realTimeSummaryResponseLength ?? 25,
        finalSummary: copilotConfigurationData?.finalSummary ?? true,
        finalSummaryResponseLength:
          copilotConfigurationData?.finalSummaryResponseLength ?? 65,
        behavioralGuidance: true,
        behavioralGuidanceResponseLength: 10,
        behevioralGuidanceNumberOfResponse: 3,
        enableExpertCopilotIntegration: true,
        expertCopilotURL: copilotConfigurationData?.expertCopilotURL ?? '',
        expertCopilotClientKey:
          copilotConfigurationData?.expertCopilotClientKey ?? '',
        expertCopilotClientSecret:
          copilotConfigurationData?.expertCopilotClientSecret ?? '',
        path: copilotConfigurationData?.path ?? '',
        botPersona: copilotConfigurationData?.botPersona ?? '',
        kBAnswersPath: copilotConfigurationData?.kBAnswersPath ?? '',
        salesOffersPath: copilotConfigurationData?.salesOffersPath ?? '',
        compliancePath: copilotConfigurationData?.compliancePath ?? '',
        knowledgeBaseArticles:
          copilotConfigurationData?.knowledgeBaseArticles ?? true,
        knowledgeBaseArticlesResponseLength:
          copilotConfigurationData?.knowledgeBaseArticlesResponseLength ?? 65,
        knowledgeBaseWebLinks:
          copilotConfigurationData?.knowledgeBaseWebLinks ?? true,
        knowledgeBaseMaximumWebLinks:
          copilotConfigurationData?.knowledgeBaseMaximumWebLinks ?? 3,
        knowledgeBaseImages:
          copilotConfigurationData?.knowledgeBaseImages ?? true,
        knowledgeBaseMaximumImages:
          copilotConfigurationData?.knowledgeBaseMaximumImages ?? 3,
        knowledgeBaseProcessSteps:
          copilotConfigurationData?.knowledgeBaseProcessSteps ?? true,
        knowledgeBaseMaximumSteps:
          copilotConfigurationData?.knowledgeBaseMaximumSteps ?? 10,
        threshold: copilotConfigurationData?.threshold ?? 0.75,
        vendorId: 'agentCopilot',
        agentAssistId: 'Ved_acp_test123',
        scriptParams: '',
        backAndForthLiveConvo:
          copilotConfigurationData?.backAndForthLiveConvo ?? false,
        backAndForthLiveConvoLength:
          copilotConfigurationData?.backAndForthLiveConvoLength ?? 4,
      },
      messageIsCompletedUtterance: true,
      agentId: 1898,
      mediaType: selectedContact?.media === 'Voice' ? 'Voice' : 'Digital',
      totalAudioChunksInMilliSeconds: 2040,
    };
    return new Promise<void>((resolve, reject) => {
      callApi(API_BASE_URL + PROCESS_UTTERANCE, 'POST', requestBody, dispatch)
        .then((response: any) => {
          resolve();
          const acp_channel: BroadcastChannel<any> = new BroadcastChannel(
            'simulator_channel'
          );
          acp_channel
            .postMessage({
              type: 'process-utterance',
              data: response.data ?? response,
            })
            .then(() => acp_channel.close())
            .catch((error) => {
              console.error(
                'Error while posting message to broadcast channel:',
                error
              );
              reject(error);
            });
        })
        .catch((error: any) => {
          console.error(
            'There was a problem with the fetch operation from simulator:',
            error
          );
          reject(error);
        });
      callApi(
        API_BASE_URL + PROCESS_UTTERANCE,
        'POST',
        { ...requestBody, getKbCombo: true },
        dispatch
      )
        .then((response: any) => {
          resolve();
          //process steps
          const matchingConfidence = selectedContact?.confidence?.find(
            (item: any) =>
              chatMessage.toLowerCase().includes(item.statement.toLowerCase())
          );

          const showGreenConfidenceDot = matchingConfidence
            ? (matchingConfidence as { value: string }).value === 'High'
            : false;
          callApi(
            API_BASE_URL + PROCESS_UTTERANCE,
            'POST',
            { ...requestBody, getProcessSteps: true },
            dispatch
          )
            .then((response: any) => {
              resolve();
              const acp_channel: BroadcastChannel<any> = new BroadcastChannel(
                'simulator_channel'
              );
              acp_channel
                .postMessage({
                  type: 'process-utterance',
                  data: response.data ?? response,
                  ignore: true,
                  showGreenConfidenceDot,
                })
                .then(() => acp_channel.close())
                .catch((error) => {
                  console.error(
                    'Error while posting message to broadcast channel:',
                    error
                  );
                  reject(error);
                });
            })
            .catch((error: any) => {
              console.error(
                'There was a problem with the fetch operation from simulator:',
                error
              );
              reject(error);
            });
          const acp_channel: BroadcastChannel<any> = new BroadcastChannel(
            'simulator_channel'
          );
          acp_channel
            .postMessage({
              type: 'process-utterance',
              data: response.data ?? response,
              showGreenConfidenceDot,
            })
            .then(() => acp_channel.close())
            .catch((error) => {
              console.error(
                'Error while posting message to broadcast channel:',
                error
              );
              reject(error);
            });
        })
        .catch((error: any) => {
          console.error(
            'There was a problem with the fetch operation from simulator:',
            error
          );
          reject(error);
        });

      // sales Offers
      if (copilotConfigurationData?.salesOffers ?? true) {
        callApi(
          API_BASE_URL + PROCESS_UTTERANCE,
          'POST',
          { ...requestBody, getSalesOffers: true },
          dispatch
        )
          .then((response: any) => {
            resolve();
            const acp_channel: BroadcastChannel<any> = new BroadcastChannel(
              'simulator_channel'
            );
            acp_channel
              .postMessage({
                type: 'process-utterance',
                data: response.data ?? response,
              })
              .then(() => acp_channel.close())
              .catch((error) => {
                console.error(
                  'Error while posting message to broadcast channel:',
                  error
                );
                reject(error);
              });
          })
          .catch((error: any) => {
            console.error(
              'There was a problem with the fetch operation from simulator:',
              error
            );
            reject(error);
          });
      }
      // complaince
      if (copilotConfigurationData?.compliance ?? true) {
        callApi(
          API_BASE_URL + PROCESS_UTTERANCE,
          'POST',
          { ...requestBody, getCompliance: true },
          dispatch
        )
          .then((response: any) => {
            resolve();
            const acp_channel: BroadcastChannel<any> = new BroadcastChannel(
              'simulator_channel'
            );
            acp_channel
              .postMessage({
                type: 'process-utterance',
                data: response.data ?? response,
              })
              .then(() => acp_channel.close())
              .catch((error) => {
                console.error(
                  'Error while posting message to broadcast channel:',
                  error
                );
                reject(error);
              });
          })
          .catch((error: any) => {
            console.error(
              'There was a problem with the fetch operation from simulator:',
              error
            );
            reject(error);
          });
      }
      // if(){
      // conversation Assistance
      callApi(
        API_BASE_URL + PROCESS_UTTERANCE,
        'POST',
        { ...requestBody, getConversationAssistance: true },
        dispatch
      )
        .then((response: any) => {
          resolve();
          const acp_channel: BroadcastChannel<any> = new BroadcastChannel(
            'simulator_channel'
          );
          acp_channel
            .postMessage({
              type: 'process-utterance',
              data: response.data ?? response,
            })
            .then(() => acp_channel.close())
            .catch((error) => {
              console.error(
                'Error while posting message to broadcast channel:',
                error
              );
              reject(error);
            });
        })
        // }
        .catch((error: any) => {
          console.error(
            'There was a problem with the fetch operation from simulator:',
            error
          );
          reject(error);
        });
    });
  };

  /**
   * Used to handle the Form Input change event and update the contact card values
   * @param field - input field name
   * @param value - input field values
   */
  const handleInputChangeForAgentHistory = (
    id: any | undefined,
    field: string,
    value: string
  ) => {
    dispatch(updateselectedAgentHistory({ id, field, value }));
  };

  /**
   * Used to handle the Form Input change event and update the contact card values
   * @param field - input field name
   * @param value - input field values
   */
  const handleInputChangeForHistory = (
    id: any | undefined,
    field: string,
    modifedtags: any,
    isFromContactHistory?: boolean
  ) => {
    const isTagsArr = modifedtags.includes(',');
    let value = [];
    if (field === 'tags' && isTagsArr) value = modifedtags.split(',');
    else value.push(modifedtags);
    if (field === 'tags') {
      dispatch(updateselectedContactHistory({ id, field, value }));
    } else {
      dispatch(updateselectedContactHistory({ id, field, value: modifedtags }));
    }
    if (isFromContactHistory && field === 'status') {
      dispatch(
        updateselectedContactHistory({
          id,
          field: 'disposition',
          value: modifedtags === 'Closed' ? modifedtags : 'Open',
        })
      );
    }
  };

  /**
   * Used to handle the Form Input change event and update the contact card values
   * @param field - input field name
   * @param value - input field values
   */
  const handleInputChangeForInteractionHistory = (
    id: any | undefined,
    field: string,
    value: any
  ) => {
    dispatch(updateselectedInteractionHistory({ id, field, value }));
  };

  //#endregion
  const handleCopilotToggle = async (isLiveCopilotEnabled: boolean) => {
    dispatch(setIsLiveCopilotEnabled(isLiveCopilotEnabled));
  };

  /**@example */
  const clearAllSimulator = () => {
    setClearSimulatorClicked(true);
    dispatch(clearAllSimulatorData());
    dispatch(setIsLiveCopilotEnabled(false));
    setToastMessage('The simulator data has been reset successfully.');
    setShowToast(true);
  };

  /**@example */
  const HandleClearSimulatorDialog = ({
    clearAllSimulator,
    openClearSimulator,
    setOpenClearSimulator,
  }: any) => {
    const dispatch = useDispatch();
    /**
     * @example
     */
    const resetDialogBox = () => {
      setOpenClearSimulator(false);
    };

    const handleClearAll = () => {
      clearAllSimulator();
      setOpenClearSimulator(false);
    };
    return (
      <CcfBox>
        <Dialog
          onClose={resetDialogBox}
          open={openClearSimulator}
          fullWidth={false}
          maxWidth="md"
          scroll="paper"
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogContent className={classes.blockContainer}>
            Are you sure you want to reset all the simulator data?
          </DialogContent>
          <DialogActions>
            <CcfButton
              sx={{ border: '1px solid #b0cddb' }}
              onClick={resetDialogBox}
            >
              <CcfTypography>No</CcfTypography>
            </CcfButton>
            <CcfButton
              primary
              onClick={() => {
                handleClearAll();
              }}
            >
              <CcfTypography>Yes</CcfTypography>
            </CcfButton>
          </DialogActions>
        </Dialog>
      </CcfBox>
    );
  };

  return (
    <>
      <Helmet>
        <title>
          {isTestEnvironment
            ? 'CXone Test Agent Simulator'
            : 'CXone Agent Simulator'}
        </title>
      </Helmet>
      <Box className={classes.simContainer}>
        {/* <FormControlLabel
          control={
            <Checkbox
              checked={isLiveCopilotEnabled}
              onChange={handleCopilotToggle}
            />
          }
          label="Copilot Live mode"
          labelPlacement="start"
          style={{
            marginLeft: '0',
            backgroundColor: '#eaf0f6',
            marginRight: '0',
          }}
        /> */}
        <Grid direction="row" container className={classes.simulatorContainer}>
          <ContactListCard
            {...{
              contact,
              selectedContactIndex,
              handleTabSelection: handleUserSelection,
            }}
          />
          <ContactDetailCard
            {...{
              selectedContact,
              handleInputChange,
              buttonText,
              handleButtonClick: broadCastMessage,
            }}
          />
          {!isLiveCopilotEnabled && (
            <CustomerDetailCard
              {...{
                selectedContact,
                handleInputChange,
                clearSimulatorClicked,
                setClearSimulatorClicked,
              }}
            />
          )}

          {!isLiveCopilotEnabled && (
            <CurrentInteraction
              interactionList={selectedContact?.recentInteraction}
              // handleCurrentInteractionChange={handleCurrentInteractionChange}
            />
          )}
          {!isLiveCopilotEnabled && (
            <AgentHistoryCard
              {...{
                selectedContact,
                agentHistoryList: selectedContact.customer.customerHistory,
                handleInputChangeForAgentHistory,
                handleInputChangeForHistory,
                handleInputChangeForInteractionHistory,
              }}
            />
          )}
          {isLiveCopilotEnabled && (
            <CopilotConfig
              {...{
                selectedContact,
                handleButtonClick: broadCastMessage,
                buttonText,
              }}
            />
          )}
          {isLiveCopilotEnabled && (
            <IndexConfig
              {...{
                selectedContact,
                handleButtonClick: broadCastMessage,
                buttonText,
                isLiveCopilotEnabled,
                setToastMessage,
                setShowToast,
                handleInputChange,
              }}
            />
          )}
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'flex-end',
              flexDirection: 'column',
            }}
            className={classes.simulatorColumn}
          >
            {((selectedContact.media === MediaType.DIGITAL &&
              selectedContact.channel === 'Chat') ||
              (selectedContact?.media === MediaType.VOICE &&
                selectedContact.copilotAssist === 'Yes')) && (
              <Paper elevation={3} className={classes.simulatorPaper}>
                <CustomerChatData
                  {...{
                    selectedContact,
                    handleInputChange,
                    handleButtonClick: broadCastMessage,
                    broadCastCopilotData: broadCastCopilotData,
                    isLiveCopilotEnabled,
                    toastMessage,
                    setToastMessage,
                    setShowToast,
                    clearSimulatorClicked,
                    setClearSimulatorClicked,
                  }}
                />
              </Paper>
            )}
            <CcfBox
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '20px',
                height: '100%',
                alignItems: 'flex-end',
              }}
            >
              <CcfButton
                primary
                // className={`${classes.btn} ${classes.saveButton}`}
                id={`sm_clearAll_simulator_button`}
                onClick={() => {
                  setOpenClearSimulator(true);
                }}
                style={{
                  margin: '25px 10px',
                  padding: '8px 20px',
                  height: '2.5rem',
                }}
              >
                <CcfTypography>Clear All</CcfTypography>
              </CcfButton>
            </CcfBox>
          </Grid>
          <CcfBox>
            <CcfSnackBar
              open={showToast}
              autoHideDuration={3000}
              onClose={() => handleClose()}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
              <div>
                <CcfAlert closeAlert={handleClose} severity="success">
                  {toastMessage}
                </CcfAlert>
              </div>
            </CcfSnackBar>
          </CcfBox>
          <HandleClearSimulatorDialog
            clearAllSimulator={clearAllSimulator}
            openClearSimulator={openClearSimulator}
            setOpenClearSimulator={setOpenClearSimulator}
          />
        </Grid>
      </Box>
    </>
  );
}

export default Simulator;

/**
 * To show the list of contacts
 * @param props - its will take the list of conatct , current selected conatct and the onclick handler method
 * @returns
 */
function ContactListCard(props: {
  contact: Contact[];
  selectedContactIndex: number;
  handleTabSelection: (value: number) => void;
}) {
  const { contact, selectedContactIndex, handleTabSelection } = props;
  return (
    <Grid className={classes.simulatorColumn}>
      <Paper elevation={6} className={classes.simulatorPaperWithFullheight}>
        {contact.map((contact: Contact, index: number) => (
          <>
            <CardActionArea
              className={`${classes.simulatorCard} ${
                selectedContactIndex === index
                  ? classes.simulatorCardSelected
                  : ''
              }`}
              id={`sm_contactList_${
                contact.customer?.firstName + ' ' + contact.customer?.lastName
              }`}
              key={index}
              onClick={() => handleTabSelection(index)}
            >
              <CardContent
                sx={{ padding: '10px' }}
                className={classes.simulatorCardContent}
              >
                <Typography color="primary">
                  {`${[
                    contact.customer?.firstName,
                    contact.customer?.middleName,
                    contact.customer?.lastName,
                  ]
                    .filter(Boolean)
                    .join(' ')}`}
                </Typography>
                <Typography color="textSecondary">
                  {contact.messageType}
                </Typography>
                <Typography color="textSecondary" variant="caption">
                  {contact.media}
                </Typography>
              </CardContent>
              <Avatar
                style={{ marginRight: '20px' }}
                aria-label="recipe"
                className={classes.avatarRoot}
                variant={'circular'}
              >
                {contact.customer?.firstName?.charAt(0)}
              </Avatar>
            </CardActionArea>
            <Divider />
          </>
        ))}
      </Paper>
    </Grid>
  );
}

/**
 * To show the contact detail for the selected contact from the contact list card. This will also let user to edit the values for the contact detail
 * @param props - it will take selected contact detail, and onchange hadnler
 * @returns
 */
function ContactDetailCard(props: {
  selectedContact: Contact;
  handleInputChange: (field: string, value: any) => void;
  buttonText: string;
  handleButtonClick: () => void;
}) {
  const { selectedContact, handleInputChange, buttonText, handleButtonClick } =
    props;
  const theme = useTheme();
  const simStyles = simulatorStyles(theme);
  return (
    <Grid className={classes.simulatorColumn}>
      <Paper elevation={3} className={classes.simulatorPaperWithFullheight}>
        <Card className={classes.heightInherit}>
          <CardHeader title="Contact Details" />
          <CardContent>
            <form
              className={classes.root + ' ' + classes.simulatorForm}
              noValidate
              autoComplete="off"
            >
              <CcfTextField
                id="sm_contactDetails_id"
                className={classes.input}
                label="ID"
                variant="outlined"
                value={selectedContact.id}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleInputChange('id', event?.target.value)
                }
                InputLabelProps={{ shrink: true }}
              />
              <CcfTextField
                className={classes.input}
                id="sm_contactDetails_messageType"
                label="Message Type"
                variant="outlined"
                value={selectedContact.messageType}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleInputChange('messageType', event?.target.value)
                }
                InputLabelProps={{ shrink: true }}
              />
              <CcfTextField
                className={classes.input}
                id="sm_contactDetails_queueName"
                label="Queue Name"
                variant="outlined"
                value={selectedContact.queueName}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleInputChange('queueName', event?.target.value)
                }
                InputLabelProps={{ shrink: true }}
              />
              <DropDown
                {...{
                  currentValue: selectedContact.media || '',
                  field: 'media',
                  label: 'Media',
                  options: ['Digital', 'Voice', 'Voicemail', 'VideoCall'],
                  handleInputChange,
                  id: `sm_contactDetails_media_${selectedContact.media}`,
                  stackName: 'contactDetails_media',
                }}
              />
              {selectedContact.media === MediaType.DIGITAL ? (
                <>
                  <DropDown
                    {...{
                      currentValue: selectedContact.channel || '',
                      field: 'channel',
                      label: 'Channel',
                      options: [
                        'Email',
                        'Instagram',
                        'X',
                        'Facebook',
                        'Linkedin',
                        'Chat',
                      ],
                      handleInputChange,
                      id: `sm_contactDetails_channel_${selectedContact.channel}`,
                      stackName: 'contactDetails_channel',
                    }}
                  />
                  {/* {
                    <DropDown
                      {...{
                        currentValue: selectedContact.copilotAssist || '',
                        field: 'copilotAssist',
                        label: 'Copilot Assist',
                        options: ['Yes', 'No'],
                        handleInputChange,
                        id: `sm_contactDetails_copilotAssist_${selectedContact.copilotAssist}`,
                        stackName: 'contactDetails_copilotAssist',
                      }}
                    />
                  } */}
                  {
                    <FormControlLabel
                      label="Activate Copilot"
                      labelPlacement="start"
                      style={simStyles.simLabelStyles}
                      control={
                        <Switch
                          name="copilotAssist"
                          color="primary"
                          checked={
                            selectedContact.copilotAssist === 'Yes'
                              ? true
                              : false
                          }
                          sx={{
                            ' .MuiFormControlLabel-label': {
                              width: 165,
                            },
                          }}
                          style={{ marginLeft: 0 }}
                          onChange={(event) =>
                            handleInputChange(
                              'copilotAssist',
                              event?.target.checked === true ? 'Yes' : 'No'
                            )
                          }
                        />
                      }
                    />
                  }
                  {selectedContact.media === MediaType.DIGITAL &&
                    (selectedContact.channel === DigitalChannelType.CHAT ||
                      selectedContact.channel === DigitalChannelType.EMAIL) &&
                    selectedContact.copilotAssist === 'Yes' && (
                      <>
                        <DropDown
                          {...{
                            currentValue: selectedContact?.copilotSource || '',
                            field: 'copilotSource',
                            label: 'Copilot Source',
                            options: ['JSON', 'Live LLM'],
                            handleInputChange,
                            id: `sm_contactDetails_copilotSource_${selectedContact.copilotSource}`,
                            stackName: 'contactDetails_copilotSource',
                          }}
                        />
                        {selectedContact?.copilotSource === 'JSON' && (
                          <FormControlLabel
                            label="Bot Transcript"
                            labelPlacement="start"
                            style={simStyles.simLabelStyles}
                            control={
                              <Switch
                                id="sm_contactDetails_botTranscript"
                                name="BotTranscript"
                                color="primary"
                                checked={selectedContact?.botTranscript}
                                sx={{
                                  ' .MuiFormControlLabel-label': {
                                    width: 165,
                                  },
                                }}
                                style={{ marginLeft: 0 }}
                                onChange={(e) =>
                                  handleInputChange(
                                    'botTranscript',
                                    e.target.checked
                                  )
                                }
                              />
                            }
                          />
                        )}
                      </>
                    )}
                </>
              ) : (
                <>
                  <DropDown
                    {...{
                      currentValue: selectedContact.contactStatus || '',
                      field: 'contactStatus',
                      label: 'Contact Status',
                      options: ['ringing', 'on hold', 'conference'],
                      handleInputChange,
                      id: `sm_contactDetails_contactStatus_${selectedContact.contactStatus}`,
                      stackName: 'contactDetails_contactStatus',
                    }}
                  />
                  {/* <DropDown
                    {...{
                      currentValue: selectedContact.copilotAssist || '',
                      field: 'copilotAssist',
                      label: 'Copilot Assist',
                      options: ['Yes', 'No'],
                      handleInputChange,
                      id: `sm_contactDetails_copilotAssist_${selectedContact.copilotAssist}`,
                      stackName: 'contactDetails_copilotAssist',
                    }}
                  /> */}
                  {
                    <FormControlLabel
                      label="Activate Copilot"
                      labelPlacement="start"
                      style={simStyles.simLabelStyles}
                      control={
                        <Switch
                          name="copilotAssist"
                          color="primary"
                          checked={
                            selectedContact.copilotAssist === 'Yes'
                              ? true
                              : false
                          }
                          sx={{
                            ' .MuiFormControlLabel-label': {
                              width: 165,
                            },
                          }}
                          style={{ marginLeft: 0 }}
                          onChange={(event) =>
                            handleInputChange(
                              'copilotAssist',
                              event?.target.checked === true ? 'Yes' : 'No'
                            )
                          }
                        />
                      }
                    />
                  }
                  {selectedContact.copilotAssist === 'Yes' && (
                    <DropDown
                      {...{
                        currentValue: selectedContact?.copilotSource || '',
                        field: 'copilotSource',
                        label: 'Copilot Source',
                        options: ['JSON', 'Live LLM'],
                        handleInputChange,
                        id: `sm_contactDetails_copilotSource_${selectedContact.copilotSource}`,
                        stackName: 'contactDetails_copilotSource',
                      }}
                    />
                  )}

                  {selectedContact?.copilotSource === 'Live LLM' && (
                    <FormControlLabel
                      label="Live Voice"
                      labelPlacement="start"
                      style={simStyles.simLabelStyles}
                      control={
                        <Switch
                          name="liveVoice"
                          color="primary"
                          checked={
                            selectedContact.liveVoice === 'Yes' ? true : false
                          }
                          sx={{
                            ' .MuiFormControlLabel-label': {
                              width: 165,
                            },
                          }}
                          style={{ marginLeft: 0 }}
                          onChange={(event) =>
                            handleInputChange(
                              'liveVoice',
                              event?.target.checked === true ? 'Yes' : 'No'
                            )
                          }
                        />
                      }
                    />
                  )}

                  <DropDown
                    {...{
                      currentValue: selectedContact.rtaStatus || '',
                      field: 'rtaStatus',
                      label: 'RTA Status',
                      options: [
                        'Authenticated',
                        'Missing Patron ID',
                        'Not Authenticated',
                      ],
                      handleInputChange,
                      id: `sm_contactDetails_rtaStatus_${selectedContact.rtaStatus}`,
                      stackName: 'contactDetails_rtaStatus',
                    }}
                  />
                  <DropDown
                    {...{
                      currentValue: selectedContact.agentAssistStatus || '',
                      field: 'agentAssistStatus',
                      label: 'Agent Assist Status',
                      options: [
                        'Negative Score',
                        'Intermediate Score',
                        'Positive Score',
                      ],
                      handleInputChange,
                      id: `sm_contactDetails_agentAssistStatus_${selectedContact.agentAssistStatus}`,
                      stackName: 'contactDetails_agentAssistStatus',
                    }}
                  />
                </>
              )}
              {selectedContact.copilotAssist === 'Yes' && (
                <>
                  <FormControlLabel
                    label="Journey History"
                    labelPlacement="start"
                    style={simStyles.simLabelStyles}
                    control={
                      <Switch
                        id="sm_contactDetails_journeyHistory"
                        name="journeyHistory"
                        color="primary"
                        checked={selectedContact?.journeyHistory}
                        sx={{
                          ' .MuiFormControlLabel-label': {
                            width: 165,
                          },
                        }}
                        style={{ marginLeft: 0 }}
                        onChange={(e) =>
                          handleInputChange('journeyHistory', e.target.checked)
                        }
                      />
                    }
                  />
                  <FormControlLabel
                    label="Agent Transfer Summary"
                    labelPlacement="start"
                    style={simStyles.simLabelStyles}
                    control={
                      <Switch
                        id="sm_contactDetails_showtransferSummary"
                        name="showtransferSummary"
                        color="primary"
                        checked={selectedContact?.showtransferSummary}
                        sx={{
                          ' .MuiFormControlLabel-label': {
                            width: 165,
                          },
                        }}
                        style={{ marginLeft: 0 }}
                        onChange={(e) =>
                          handleInputChange(
                            'showtransferSummary',
                            e.target.checked
                          )
                        }
                      />
                    }
                  />
                </>
              )}              
              <CcfTextField
                className={classes.input}
                id={`sm_contactDetails_crmLabel`}
                label="CRM Label"
                variant="outlined"
                value={selectedContact.crmLabel}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleInputChange('crmLabel', event?.target.value)
                }
                InputLabelProps={{ shrink: true }}
              />
              <CcfTextField
                className={classes.input}
                id={`sm_contactDetails_crmUrl`}
                label="CRM URL"
                variant="outlined"
                value={selectedContact.crmUrl}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleInputChange('crmUrl', event?.target.value)
                }
                InputLabelProps={{ shrink: true }}
              />
            </form>
          </CardContent>
          <CardActions>
            <Button
              id={`sm_contactDetails_button`}
              size="large"
              variant="contained"
              color="primary"
              className={classes.simulatorButton}
              onClick={handleButtonClick}
            >
              {buttonText}
            </Button>
          </CardActions>
        </Card>
      </Paper>
    </Grid>
  );
}

/**@example */
const EditCustomer = ({
  openEditCustomerDialog,
  setOpenEditCustomerDialog,
  selectedContact,
  handleInputChange,
  editCustomerDetails,
  setEditCustomerDetails,
}: any) => {
  const dispatch = useDispatch();
  /**
   * @example
   */
  const resetEditDialogBox = () => {
    setOpenEditCustomerDialog(false);
  };

  const handleSaveCustomerDetails = () => {
    dispatch(updateselectedCustomer(editCustomerDetails));
    setOpenEditCustomerDialog(false);
  };
  return (
    <CcfBox>
      <Dialog
        onClose={resetEditDialogBox}
        open={openEditCustomerDialog}
        fullWidth={true}
        maxWidth="md"
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle sx={{ fontWeight: '600' }}>
          {'Edit Customer Details'}
        </DialogTitle>
        <DialogContent className={classes.blockContainer}>
          <CcfBox className={classes.feildBlock}>
            <CcfTypography className={classes.tableHeaderText}>
              First Name
            </CcfTypography>
            <CcfTextField
              id="firstName"
              variant="outlined"
              size="small"
              value={
                editCustomerDetails?.firstName
                  ? editCustomerDetails?.firstName
                  : ''
              }
              focused={false}
              style={{ width: '80%' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEditCustomerDetails({
                  ...editCustomerDetails,
                  firstName: event.target.value,
                });
              }}
            />{' '}
          </CcfBox>
          <CcfBox className={classes.feildBlock}>
            <CcfTypography className={classes.tableHeaderText}>
              Middle Name
            </CcfTypography>
            <CcfTextField
              id="lastName"
              variant="outlined"
              size="small"
              value={
                editCustomerDetails?.middleName
                  ? editCustomerDetails?.middleName
                  : ''
              }
              focused={false}
              style={{ width: '80%' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEditCustomerDetails({
                  ...editCustomerDetails,
                  middleName: event.target.value,
                });
              }}
            />{' '}
          </CcfBox>
          <CcfBox className={classes.feildBlock}>
            <CcfTypography className={classes.tableHeaderText}>
              Last Name
            </CcfTypography>
            <CcfTextField
              id="lastName"
              variant="outlined"
              size="small"
              value={
                editCustomerDetails?.lastName
                  ? editCustomerDetails?.lastName
                  : ''
              }
              focused={false}
              style={{ width: '80%' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEditCustomerDetails({
                  ...editCustomerDetails,
                  lastName: event.target.value,
                });
              }}
            />{' '}
          </CcfBox>
        </DialogContent>
        <DialogActions>
          <CcfButton onClick={resetEditDialogBox}>
            <CcfTypography>Cancel</CcfTypography>
          </CcfButton>
          <CcfButton primary onClick={handleSaveCustomerDetails}>
            <CcfTypography>Save</CcfTypography>
          </CcfButton>
        </DialogActions>
      </Dialog>
    </CcfBox>
  );
};

/**@example */
const EditCustomerAddress = ({
  openEditCustomerAddressDialog,
  setOpenEditCustomerAddressDialog,
  selectedContact,
  editCustomerDetails,
  setEditCustomerDetails,
}: any) => {
  const dispatch = useDispatch();
  /**
   * @example
   */
  const resetEditDialogBox = () => {
    setOpenEditCustomerAddressDialog(false);
  };

  const handleSaveCustomerDetails = () => {
    dispatch(updateselectedCustomer(editCustomerDetails));
    setOpenEditCustomerAddressDialog(false);
  };
  return (
    <CcfBox>
      <Dialog
        onClose={resetEditDialogBox}
        open={openEditCustomerAddressDialog}
        fullWidth={true}
        maxWidth="md"
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle sx={{ fontWeight: '600' }}>
          {'Edit Customer Address Details'}
        </DialogTitle>
        <DialogContent className={classes.blockContainer}>
          <CcfBox className={classes.feildBlock}>
            <CcfTypography className={classes.tableHeaderText}>
              Address Line 1
            </CcfTypography>
            <CcfTextField
              id="confirmPassword"
              variant="outlined"
              size="small"
              value={editCustomerDetails.customerPrimaryAddress?.address1}
              focused={false}
              style={{ width: '80%' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEditCustomerDetails({
                  ...editCustomerDetails,
                  customerPrimaryAddress: {
                    ...editCustomerDetails.customerPrimaryAddress,
                    address1: event.target.value,
                  },
                  customerSecondaryAddress: {
                    ...editCustomerDetails.customerSecondaryAddress,
                    address1: event.target.value,
                  },
                });
              }}
            />{' '}
          </CcfBox>
          <CcfBox className={classes.feildBlock}>
            <CcfTypography className={classes.tableHeaderText}>
              Address Line 2
            </CcfTypography>
            <CcfTextField
              id="address2"
              variant="outlined"
              size="small"
              value={editCustomerDetails.customerPrimaryAddress?.address2}
              focused={false}
              style={{ width: '80%' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEditCustomerDetails({
                  ...editCustomerDetails,
                  customerPrimaryAddress: {
                    ...editCustomerDetails.customerPrimaryAddress,
                    address2: event.target.value,
                  },
                  customerSecondaryAddress: {
                    ...editCustomerDetails.customerSecondaryAddress,
                    address2: event.target.value,
                  },
                });
              }}
            />{' '}
          </CcfBox>
          <CcfBox className={classes.feildBlock}>
            <CcfTypography className={classes.tableHeaderText}>
              City
            </CcfTypography>
            <CcfTextField
              id="confirmPassword"
              variant="outlined"
              size="small"
              value={editCustomerDetails.customerPrimaryAddress?.city}
              focused={false}
              style={{ width: '80%' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEditCustomerDetails({
                  ...editCustomerDetails,
                  customerPrimaryAddress: {
                    ...editCustomerDetails.customerPrimaryAddress,
                    city: event.target.value,
                  },
                  customerSecondaryAddress: {
                    ...editCustomerDetails.customerSecondaryAddress,
                    city: event.target.value,
                  },
                });
              }}
            />{' '}
          </CcfBox>
          <CcfBox className={classes.feildBlock}>
            <CcfTypography className={classes.tableHeaderText}>
              Zip
            </CcfTypography>
            <CcfTextField
              id="confirmPassword"
              variant="outlined"
              size="small"
              value={editCustomerDetails.customerPrimaryAddress?.zip}
              focused={false}
              style={{ width: '80%' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEditCustomerDetails({
                  ...editCustomerDetails,
                  customerPrimaryAddress: {
                    ...editCustomerDetails.customerPrimaryAddress,
                    zip: event.target.value,
                  },
                  customerSecondaryAddress: {
                    ...editCustomerDetails.customerSecondaryAddress,
                    zip: event.target.value,
                  },
                });
              }}
            />{' '}
          </CcfBox>
          <CcfBox className={classes.feildBlock}>
            <CcfTypography className={classes.tableHeaderText}>
              State
            </CcfTypography>
            <CcfTextField
              id="confirmPassword"
              variant="outlined"
              size="small"
              value={editCustomerDetails.customerPrimaryAddress?.state}
              focused={false}
              style={{ width: '80%' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEditCustomerDetails({
                  ...editCustomerDetails,
                  customerPrimaryAddress: {
                    ...editCustomerDetails.customerPrimaryAddress,
                    state: event.target.value,
                  },
                  customerSecondaryAddress: {
                    ...editCustomerDetails.customerSecondaryAddress,
                    state: event.target.value,
                  },
                });
              }}
            />{' '}
          </CcfBox>
          <CcfBox className={classes.feildBlock}>
            <CcfTypography className={classes.tableHeaderText}>
              Country
            </CcfTypography>
            <CcfTextField
              id="confirmPassword"
              variant="outlined"
              size="small"
              value={editCustomerDetails.customerPrimaryAddress?.country}
              focused={false}
              style={{ width: '80%' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEditCustomerDetails({
                  ...editCustomerDetails,
                  customerPrimaryAddress: {
                    ...editCustomerDetails.customerPrimaryAddress,
                    country: event.target.value,
                  },
                  customerSecondaryAddress: {
                    ...editCustomerDetails.customerSecondaryAddress,
                    country: event.target.value,
                  },
                });
              }}
            />{' '}
          </CcfBox>
        </DialogContent>
        <DialogActions>
          <CcfButton onClick={resetEditDialogBox}>
            <CcfTypography>Cancel</CcfTypography>
          </CcfButton>
          <CcfButton primary onClick={handleSaveCustomerDetails}>
            <CcfTypography>Save</CcfTypography>
          </CcfButton>
        </DialogActions>
      </Dialog>
    </CcfBox>
  );
};
function CustomerDetailCard(props: {
  selectedContact: Contact;
  handleInputChange: any;
  clearSimulatorClicked: any;
  setClearSimulatorClicked: any;
}) {
  const locale = useSelector(getApplicationLocale);
  const dispatch = useDispatch();
  const {
    selectedContact,
    handleInputChange,
    clearSimulatorClicked,
    setClearSimulatorClicked,
  } = props;
  const [customLabel1, setCustomLabel1] = useState('CXone Expert');
  const [openEditCustomerDialog, setOpenEditCustomerDialog] = useState(false);
  const [openEditCustomerAddressDialog, setOpenEditCustomerAddressDialog] =
    useState(false);
  const [editCustomerDetails, setEditCustomerDetails] = useState(
    JSON.parse(JSON.stringify(selectedContact.customer))
  );
  const [notesData, setNotesData] = useState(
    JSON.parse(JSON.stringify(selectedContact.notes))
  );
  const [customLabel2, setCustomLabel2] = useState('PM SSO');
  const [customLabel3, setCustomLabel3] = useState('Surfly');
  const [customURL1, setcustomURL1] = useState(
    'https://chimericalcorporation.com/expert'
  );
  const [customURL2, setcustomURL2] = useState(
    'https://demo-cxonepm.clearviewportal.com'
  );
  const [setcustomURL3, setsetcustomURL3] = useState(
    'https://surfly-cxone-953a75b368ee.herokuapp.com/'
  );

  useEffect(() => {
    if (clearSimulatorClicked) {
      setCustomLabel1('CXone Expert');
      setcustomURL1('https://chimericalcorporation.com/expert');
      setCustomLabel2('PM SSO');
      setcustomURL2('https://demo-cxonepm.clearviewportal.com');
      setCustomLabel3('Surfly');
      setsetcustomURL3('https://surfly-cxone-953a75b368ee.herokuapp.com/');
      setClearSimulatorClicked(false);
    }
  }, [clearSimulatorClicked]);
  useEffect(() => {
    setNotesData(JSON.parse(JSON.stringify(selectedContact.notes)));
  }, [selectedContact?.notes]);

  useEffect(() => {
    setEditCustomerDetails(
      JSON.parse(JSON.stringify(selectedContact.customer))
    );
  }, [selectedContact?.customer]);

  /**
   * to save custom workspace panel in local storage
   * @param args - none,
   * @example saveCustomWorkspaceHandler()
   */
  const saveCustomWorkspaceHandler = () => {
    let customWorkspacepanel = [
      {
        persistentPanelId: 1,
        persistentPanelLabel: customLabel1,
        persistentPanelURI: customURL1,
      },
    ];
    if (customLabel2.length > 0) {
      customWorkspacepanel = [
        ...customWorkspacepanel,
        {
          persistentPanelId: 2,
          persistentPanelLabel: customLabel2,
          persistentPanelURI: customURL2,
        },
      ];
    }
    if (customLabel3.length > 0) {
      customWorkspacepanel = [
        ...customWorkspacepanel,
        {
          persistentPanelId: 3,
          persistentPanelLabel: customLabel3,
          persistentPanelURI: setcustomURL3,
        },
      ];
    }
    localStorage.setItem(
      'customWorkspacePanel',
      JSON.stringify(customWorkspacepanel)
    );
  };

  /**
   * to make save button disabled or enabled in custom workspace
   * @param args - none,
   * @example isSaveBtnDisabled()
   */
  const isSaveBtnDisabled = () => {
    if (
      customLabel1 &&
      customURL1 &&
      !customLabel2 &&
      !customURL2 &&
      !customLabel3 &&
      !setcustomURL3
    ) {
      return false;
    } else if (
      customLabel1 &&
      customURL1 &&
      customLabel2 &&
      customURL2 &&
      !customLabel3 &&
      !setcustomURL3
    ) {
      return false;
    } else if (
      customLabel1 &&
      customURL1 &&
      customLabel2 &&
      customURL2 &&
      customLabel3 &&
      setcustomURL3
    ) {
      return false;
    } else {
      return true;
    }
  };

  /**@example */
  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    label: string
  ) => {
    const editConsumerCardDetails = {
      ...editCustomerDetails,
      [label]: event,
    };
    dispatch(updateselectedCustomer(editConsumerCardDetails));
  };
  /**
   * Used to display date picker icon
   * @example - DatePickerIcon()
   */
  const DatePickerIcon = () => {
    return (
      <CcfBox sx={{ display: 'flex' }}>
        <CcfDatePickerIcon />
      </CcfBox>
    );
  };
  return (
    <Grid className={classes.simulatorColumn}>
      <Paper elevation={3} className={classes.simulatorPaperWithFullheight}>
        <Card>
          <CardHeader title="Customer Details" />
          <CardContent>
            <form
              className={classes.root + ' ' + classes.simulatorForm}
              noValidate
              autoComplete="off"
            >
              <CcfTextField
                className={classes.input}
                id={`sm_customerDetails_customerName`}
                label="Name"
                variant="outlined"
                value={
                  `${[
                    selectedContact.customer?.firstName,
                    selectedContact.customer?.middleName,
                    selectedContact.customer?.lastName,
                  ]
                    .filter(Boolean)
                    .join(' ')}` || ''
                }
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleInputChange('customerName', event?.target.value)
                }
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <CcfTooltip title={'Edit Customer Details'} arrow>
                        <IconButton
                          onClick={() => {
                            setOpenEditCustomerDialog(true);
                          }}
                        >
                          <CcfEditIcon
                            style={{
                              fontSize: '17px',
                              marginTop: '-31px',
                              marginRight: '-20px',
                            }}
                          />
                        </IconButton>
                      </CcfTooltip>
                    </InputAdornment>
                  ),
                }}
              />
              <CcfTextField
                className={classes.input}
                id="sm_customerDetails_customerAddress"
                label="Address"
                variant="outlined"
                value={
                  selectedContact.customer.customerPrimaryAddress?.address1 +
                  ',' +
                  selectedContact.customer.customerPrimaryAddress?.address2 +
                  ',' +
                  selectedContact.customer.customerPrimaryAddress?.city +
                  ',' +
                  selectedContact.customer.customerPrimaryAddress?.zip +
                  ',' +
                  selectedContact.customer.customerPrimaryAddress?.state +
                  ',' +
                  selectedContact.customer.customerPrimaryAddress?.country
                }
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleInputChange('customerAddress', event?.target.value)
                }
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <CcfTooltip title={'Edit Customer Address'} arrow>
                        <IconButton
                          onClick={() => {
                            setOpenEditCustomerAddressDialog(true);
                          }}
                        >
                          <CcfEditIcon
                            style={{
                              fontSize: '17px',
                              marginTop: '-31px',
                              marginRight: '-20px',
                            }}
                          />
                        </IconButton>
                      </CcfTooltip>
                    </InputAdornment>
                  ),
                }}
              />
              {selectedContact.channel === 'Email' && (
                <>
                  <CcfTextField
                    className={classes.input}
                    id="sm_customerDetails_customerEmailid"
                    label="Email"
                    variant="outlined"
                    value={selectedContact.customer.emailId}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                      handleInputChange('emailId', event?.target.value)
                    }
                    InputLabelProps={{ shrink: true }}
                  />
                  <DropDown
                    {...{
                      currentValue:
                        selectedContact.customer.replywithApproval || '',
                      field: 'replywithApproval',
                      label: 'Reply With Approval',
                      options: ['Yes', 'No'],
                      handleInputChange,
                      id: `sm_customerDetails_replywithApproval_${selectedContact.customer.replywithApproval}`,
                      stackName: 'customerDetails_replywithApproval',
                    }}
                  />
                </>
              )}
              <CcfTextField
                className={classes.input}
                id="sm_customerDetails_screenPopURL"
                label="Screen Pop URL"
                variant="outlined"
                value={selectedContact.screenPopURL}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleInputChange('screenPopURL', event?.target.value)
                }
                InputLabelProps={{ shrink: true }}
              />
              <DropDown
                {...{
                  currentValue: selectedContact.screenPopPreference || '',
                  field: 'screenPopPreference',
                  label: 'Screen Pop Preference',
                  options: ['Off', 'New Tab', 'External Window'],
                  handleInputChange,
                  id: `sm_customerDetails_screenPopPreference_${selectedContact.screenPopPreference}`,
                  stackName: 'customerDetails_screenPopPreference',
                }}
              />
              {(selectedContact.media === MediaType.VOICE ||
                selectedContact.channel === DigitalChannelType.CHAT) && (
                <DropDown
                  {...{
                    currentValue: selectedContact.autoSummary || '',
                    field: 'autoSummary',
                    label: 'Auto Summary',
                    options: ['Off', 'On', 'Custom'],
                    handleInputChange,
                    id: `sm_customerDetails_autoSummary_${selectedContact.autoSummary}`,
                    stackName: 'customerDetails_autoSummary',
                  }}
                />
              )}
              {selectedContact.autoSummary === 'Custom' && (
                <>
                  <CcfTypography className={classes.autoSummary_text}>
                    Autosummary Text
                  </CcfTypography>
                  <textarea
                    id="sm_customerDetails_autoSummaryText"
                    className={classes.autoSummary_textarea}
                    defaultValue={
                      'The customer called to request new insurance cards for their daughter, mentioning their employment with the company. The agent confirmed the policy number and offered assistance with ordering the cards. The agent provided information about the delivery timeframe of 10 business days. They also informed the customer about eligibility for a covered annual physical. The issue was resolved successfully.'
                    }
                    value={selectedContact.autoSummaryText}
                    onChange={(event: any) =>
                      handleInputChange('autoSummaryText', event?.target.value)
                    }
                  ></textarea>
                </>
              )}
            </form>
          </CardContent>
        </Card>

        <Card>
          <CardHeader
            style={{ paddingBottom: '0px' }}
            title={`Overview Tab Details`}
          />
          <CardContent style={{ paddingBottom: '0px' }}>
            <CcfBox
              style={{
                height: '480px',
              }}
            >
              <Carousel
                autoPlay={false}
                indicators={true}
                animation="slide"
                navButtonsAlwaysVisible={false}
                className={classes.carousel}
                fullHeightHover={true}
                navButtonsProps={{
                  style: {
                    display: 'none',
                  },
                }}
                navButtonsWrapperProps={{
                  style: {
                    display: 'none',
                  },
                }}
              >
                {notesData?.slice(0, 3).map((note: any, index: any) => (
                  <CcfBox key={index}>
                    <CcfTextField
                      fullWidth
                      color="primary"
                      id="sm_overviewTab_notes_title"
                      style={{ marginBottom: '10px', marginTop: '5px' }}
                      className={classes.input}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ classes: { input: classes.p10 } }}
                      value={note.noteTitle}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        const updatedData = [...notesData];
                        updatedData[index] = {
                          ...updatedData[index],
                          noteTitle: event?.target.value,
                        };

                        setNotesData(updatedData);
                        dispatch(
                          updateselectedContact({
                            field: 'notes',
                            value: updatedData,
                          })
                        );
                      }}
                      label={'Note Title'}
                      variant="outlined"
                    ></CcfTextField>
                    <CcfBox
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '5px',
                      }}
                    >
                      <CcfTypography style={{ fontSize: '14px' }}>
                        Note Subtitle
                      </CcfTypography>
                      <CcfBox className={classes.editBox}>
                        <textarea
                          id="editNote"
                          name="editNote"
                          style={{ height: '50px' }}
                          className={classes.note_textarea}
                          value={note.subTitle}
                          onChange={(
                            event: React.ChangeEvent<HTMLTextAreaElement>
                          ) => {
                            const updatedData = [...notesData];
                            updatedData[index] = {
                              ...updatedData[index],
                              subTitle: event?.target.value,
                            };

                            setNotesData(updatedData);
                            dispatch(
                              updateselectedContact({
                                field: 'notes',
                                value: updatedData,
                              })
                            );
                          }}
                        ></textarea>
                      </CcfBox>
                    </CcfBox>
                    <CcfBox
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '5px',
                      }}
                    >
                      <CcfTypography style={{ fontSize: '14px' }}>
                        Note Content
                      </CcfTypography>
                      <CcfBox className={classes.editBox}>
                        <textarea
                          id="editNote"
                          style={{ height: '120px' }}
                          className={classes.note_textarea}
                          value={note.noteContent}
                          onChange={(
                            event: React.ChangeEvent<HTMLTextAreaElement>
                          ) => {
                            const updatedData = [...notesData];
                            updatedData[index] = {
                              ...updatedData[index],
                              noteContent: event?.target.value,
                            };

                            setNotesData(updatedData);
                            dispatch(
                              updateselectedContact({
                                field: 'notes',
                                value: updatedData,
                              })
                            );
                          }}
                        ></textarea>
                      </CcfBox>
                    </CcfBox>
                    <div style={{ marginTop: '10px' }}>
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale={locale}
                        id="sm_overviewTab_date"
                      >
                        <CcfBox data-testid="date-input">
                          <DateTimePicker
                            label="Date"
                            value={dayjs(note.date)}
                            onChange={(event: any) => {
                              const updatedData = [...notesData];
                              updatedData[index] = {
                                ...updatedData[index],
                                date: new Date(event).toISOString(),
                              };

                              setNotesData(updatedData);
                              dispatch(
                                updateselectedContact({
                                  field: 'notes',
                                  value: updatedData,
                                })
                              );
                            }}
                            renderInput={(props: any) => (
                              <CcfTextField
                                fullWidth
                                variant="outlined"
                                color="primary"
                                style={{ marginBottom: '15px' }}
                                className={classes.input}
                                InputProps={{
                                  classes: { input: classes.p10 },
                                }}
                                id="date"
                                InputLabelProps={{ shrink: true }}
                                {...props}
                              />
                            )}
                            components={{
                              OpenPickerIcon: DatePickerIcon,
                            }}
                          />
                        </CcfBox>
                      </LocalizationProvider>
                    </div>
                    <CcfTextField
                      fullWidth
                      color="primary"
                      id="sm_overviewTab_agentName"
                      style={{ marginBottom: '15px', marginTop: '5px' }}
                      className={classes.input}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ classes: { input: classes.p10 } }}
                      value={note.agentName}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        const updatedData = [...notesData];
                        updatedData[index] = {
                          ...updatedData[index],
                          agentName: event?.target.value,
                        };

                        setNotesData(updatedData);
                        dispatch(
                          updateselectedContact({
                            field: 'notes',
                            value: updatedData,
                          })
                        );
                      }}
                      label={'Agent Name'}
                      variant="outlined"
                    ></CcfTextField>
                  </CcfBox>
                ))}
              </Carousel>
            </CcfBox>
          </CardContent>
        </Card>
        <Card style={{ borderRadius: '0px' }}>
          <CardHeader title="Consumer Card Details" />
          <CardContent style={{ paddingTop: '0' }}>
            <CcfBox className={classes.root + ' ' + classes.simulatorForm}>
              <FormControl>
                <FormGroup>
                  <FormControlLabel
                    label="Show External Data Loyalty Card Section"
                    labelPlacement="start"
                    control={
                      <Switch
                        // id="sm_contactDetails_botTranscript"
                        name="Show External Data Loyalty Card Section"
                        color="primary"
                        checked={
                          selectedContact.customer?.externalDataLoyaltyInfoHide
                        }
                        sx={{
                          ' .MuiFormControlLabel-label': {
                            width: 165,
                          },
                        }}
                        onChange={(event: any) =>
                          handleCheckboxChange(
                            event.target.checked,
                            'externalDataLoyaltyInfoHide'
                          )
                        }
                      />
                    }
                    style={{ marginLeft: 0 }}
                    className={classes.label}
                  />{' '}
                  <FormControlLabel
                    label="Show Tickets Tab"
                    labelPlacement="start"
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginLeft: 0,
                    }}
                    className={classes.label}
                    control={
                      <Switch
                        // id="sm_contactDetails_botTranscript"
                        name="Show Tickets Tab"
                        color="primary"
                        checked={
                          selectedContact.customer?.consumerCardTicketTabHide
                        }
                        sx={{
                          ' .MuiFormControlLabel-label': {
                            width: 175,
                          },
                        }}
                        onChange={(event: any) =>
                          handleCheckboxChange(
                            event.target.checked,
                            'consumerCardTicketTabHide'
                          )
                        }
                      />
                    }
                  />{' '}
                </FormGroup>
              </FormControl>
            </CcfBox>
          </CardContent>
        </Card>
        <Card className={classes.heightInherit}>
          <CardHeader title="Custom Workspace" />
          <CardContent>
            <form
              className={classes.root + ' ' + classes.simulatorForm}
              noValidate
              autoComplete="off"
            >
              <CcfTextField
                id="sm_customWorkspace_Label1"
                className={classes.input}
                label="Label 1"
                variant="outlined"
                value={customLabel1}
                onChange={(e: any) => setCustomLabel1(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
              <CcfTextField
                id="sm_customWorkspace_Url1"
                className={classes.input}
                label="URL 1"
                variant="outlined"
                value={customURL1}
                onChange={(e: any) => setcustomURL1(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
              <CcfTextField
                id="sm_customWorkspace_Label2"
                className={classes.input}
                label="Label 2"
                variant="outlined"
                value={customLabel2}
                onChange={(e: any) => setCustomLabel2(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
              <CcfTextField
                id="sm_customWorkspace_Url2"
                className={classes.input}
                label="URL 2"
                variant="outlined"
                value={customURL2}
                onChange={(e: any) => setcustomURL2(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
              <CcfTextField
                id="sm_customWorkspace_Label3"
                className={classes.input}
                label="Label 3"
                variant="outlined"
                value={customLabel3}
                onChange={(e: any) => setCustomLabel3(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
              <CcfTextField
                id="sm_customWorkspace_Url3"
                className={classes.input}
                label="URL 3"
                variant="outlined"
                value={setcustomURL3}
                onChange={(e: any) => setsetcustomURL3(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </form>
          </CardContent>
          <CardActions className={classes.simulatorSaveButton}>
            <Button
              id="sm_customWorkspace_save"
              size="large"
              variant="contained"
              color="primary"
              onClick={saveCustomWorkspaceHandler}
              disabled={isSaveBtnDisabled()}
            >
              Save
            </Button>
          </CardActions>
        </Card>
      </Paper>
      <EditCustomer
        openEditCustomerDialog={openEditCustomerDialog}
        setOpenEditCustomerDialog={setOpenEditCustomerDialog}
        selectedContact={selectedContact}
        editCustomerDetails={editCustomerDetails}
        setEditCustomerDetails={setEditCustomerDetails}
      />

      <EditCustomerAddress
        openEditCustomerAddressDialog={openEditCustomerAddressDialog}
        setOpenEditCustomerAddressDialog={setOpenEditCustomerAddressDialog}
        selectedContact={selectedContact}
        editCustomerDetails={editCustomerDetails}
        setEditCustomerDetails={setEditCustomerDetails}
      />
    </Grid>
  );
}

/**
 * To show the list of agent history in the simulator
 * @param props - it will take the agent history list, button text and onclick handler
 * @returns
 */
function AgentHistoryCard(props: {
  selectedContact: any;
  agentHistoryList: CustomerHistory[] | undefined;
  handleInputChangeForAgentHistory: (
    id: any | undefined,
    field: string,
    value: string
  ) => void;
  handleInputChangeForHistory: (
    id: any | undefined,
    field: string,
    modifedtags: any,
    isFromContactHistory?: boolean
  ) => void;
  handleInputChangeForInteractionHistory: (
    id: any | undefined,
    field: string,
    value: any
  ) => void;
}) {
  const {
    agentHistoryList,
    handleInputChangeForAgentHistory,
    selectedContact,
  } = props;
  const styles = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();

  const [isAgentHistoryExpanded, setIsAgentHistoryExpanded] = useState(false);

  const simStyles = simulatorStyles(theme);
  const [expanded, setExpanded] = React.useState(null);

  const handleChange = (panel: any) => (_: any, isExpanded: any) => {
    setExpanded(isExpanded ? panel : null);
    setExpanded((state) => {
      return state;
    });
  };

  return (
    <Grid className={classes.simulatorColumn}>
      <Paper elevation={3} className={classes.simulatorPaperWithFullheight}>
        {/* <Card className={classes.heightAuto}>
          <CardHeader
            title={`Agent History`}
            onClick={() => setIsAgentHistoryExpanded(!isAgentHistoryExpanded)}
          />
          {!agentHistoryList ? (
            <CardContent className={classes.centerAlign}>
              <Typography color="textSecondary">No Agent History.</Typography>
            </CardContent>
          ) : (
            isAgentHistoryExpanded && (
              <CardContent
                className={
                  classes.simulatorHistoryContent + ' ' + classes.fixedHeight
                }
              >
                {agentHistoryList.map((contactHistory, index) => {
                  const contactHIstoryId = contactHistory.id;
                  return (
                    <CcfAccordion
                      square
                      sx={simStyles.accordionContainer}
                      expanded={expanded === contactHistory.id}
                      onChange={handleChange(contactHistory.id)}
                    >
                      <CcfAccordionSummary
                        expandIcon={
                          <CcfDoubleArrowIcon sx={simStyles.expandedIcon} />
                        }
                        aria-controls="detail-content"
                        id={`sm_agentHistory_${contactHistory.contactName}_agentName`}
                        sx={simStyles.accordionHeader}
                      >
                        <Typography>{contactHistory.contactName}</Typography>
                      </CcfAccordionSummary>
                      <CcfAccordionDetails classes={{ root: styles.root }}>
                        <CardActionArea key={'index'}>
                          <CardContent style={{ padding: '0px' }}>
                            <CcfTextField
                              color="primary"
                              id={`sm_agentHistory_${contactHistory.contactName}_contactName`}
                              style={{ marginBottom: '15px' }}
                              className={classes.input}
                              InputLabelProps={{ shrink: true }}
                              InputProps={{ classes: { input: classes.p10 } }}
                              value={contactHistory.contactName}
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>
                              ) =>
                                handleInputChangeForAgentHistory(
                                  contactHistory.id,
                                  'contactName',
                                  event?.target.value
                                )
                              }
                              label={'Contact Name'}
                              variant="outlined"
                            ></CcfTextField>
                            <CcfTextField
                              id={`sm_agentHistory_${contactHistory.contactName}_contactTrackingId`}
                              color="primary"
                              style={{ marginBottom: '15px' }}
                              className={classes.input}
                              InputProps={{ classes: { input: classes.p10 } }}
                              InputLabelProps={{ shrink: true }}
                              value={contactHistory.contactTrackingId}
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>
                              ) =>
                                handleInputChangeForAgentHistory(
                                  contactHistory.id,
                                  'contactTrackingId',
                                  event?.target.value
                                )
                              }
                              label={'Contact Tracking Id'}
                              variant="outlined"
                            ></CcfTextField>
                            <CcfTextField
                              color="primary"
                              id={`sm_agentHistory_${contactHistory.contactName}_contactId`}
                              style={{ marginBottom: '15px' }}
                              className={classes.input}
                              InputProps={{ classes: { input: classes.p10 } }}
                              InputLabelProps={{ shrink: true }}
                              value={contactHistory.contactId}
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>
                              ) =>
                                handleInputChangeForAgentHistory(
                                  contactHistory.id,
                                  'contactId',
                                  event?.target.value
                                )
                              }
                              label={'Contact Id'}
                              variant="outlined"
                            ></CcfTextField>
                            <br />
                            <CcfTextField
                              color="primary"
                              id={`sm_agentHistory_${contactHistory.contactName}_contactRequest`}
                              style={{ marginBottom: '15px' }}
                              className={classes.input}
                              InputProps={{ classes: { input: classes.p10 } }}
                              InputLabelProps={{ shrink: true }}
                              value={contactHistory.contactRequest}
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>
                              ) =>
                                handleInputChangeForAgentHistory(
                                  contactHistory.id,
                                  'contactRequest',
                                  event?.target.value
                                )
                              }
                              label={'Contact Request'}
                              variant="outlined"
                            ></CcfTextField>
                            <br />
                            <DropDown
                              {...{
                                isFromContactHistory: true,
                                customerHistoryId: contactHistory.id,
                                currentValue: contactHistory.contactStatus,
                                field: 'contactStatus',
                                label: 'Status',
                                options: [
                                  'New',
                                  'Open',
                                  'Pending',
                                  'Resolved',
                                  'Escalated',
                                  'Closed',
                                ],
                                handleInputChangeForAgentHistory,
                                id: `sm_agentHistory_${contactHistory.contactName}_status_${contactHistory.contactStatus}`,
                                stackName: `agentHistory_${contactHistory.contactName}_status`,
                              }}
                            />
                            <br />
                            <DropDown
                              {...{
                                isFromContactHistory: true,
                                customerHistoryId: contactHistory.id,
                                currentValue: contactHistory.digitalChannel,
                                field: 'digitalChannel',
                                label: 'Channel',
                                options: [
                                  'digital',
                                  'email',
                                  'voice',
                                  'contactprofile',
                                ],
                                handleInputChangeForAgentHistory,
                                id: `sm_agentHistory_${contactHistory.contactName}_channel_${contactHistory.digitalChannel}`,
                                stackName: `agentHistory_${contactHistory.contactName}_channel`,
                              }}
                            />
                          </CardContent>
                        </CardActionArea>
                        <Divider />
                      </CcfAccordionDetails>
                    </CcfAccordion>
                  );
                })}
              </CardContent>
            )
          )}
        </Card> */}

        <ContactHistoryCard
          contactHistoryList={props.selectedContact?.contactHistoryList}
          handleInputChangeForHistory={props.handleInputChangeForHistory}
        />

        <InteractionsHistoryCard
          interactionHistoryList={props.selectedContact?.interactionHistoryList}
          handleInputChangeForInteractionHistory={
            props.handleInputChangeForInteractionHistory
          }
          selectedContact={selectedContact}
        />
      </Paper>
    </Grid>
  );
}

/**
 * To show the contact detail for the selected contact from the contact list card. This will also let user to edit the values for the contact detail
 * @param props - it will take selected contact detail, and onchange hadnler
 * @returns
 */
function IndexConfig(props: {
  selectedContact: Contact;
  handleButtonClick: () => void;
  buttonText: string;
  isLiveCopilotEnabled: boolean;
  setToastMessage: any;
  setShowToast: any;
  handleInputChange: any;
}) {
  const { accounts } = useMsal();
  const loggedInUser = accounts[0]?.username?.toLowerCase();
  const copilotConfiguration: any = useSelector(getCopilotConfig);

  const [localConfiguration, setLocalConfiguration] =
    useState(copilotConfiguration);
  const {
    selectedContact,
    isLiveCopilotEnabled,
    setToastMessage,
    setShowToast,
    handleInputChange,
  } = props;
  const dispatch = useDispatch();
  const expertSystemOptionsFromSelector = useSelector(getExpertSystemOptions);
  const [expertSystemOptions, setExpertSystemOptions] = useState(
    expertSystemOptionsFromSelector
  );

  const demoType = localConfiguration?.demoType;

  useEffect(() => {
    callApi(API_BASE_URL + EXPERT_VERTICALS, 'GET')
      .then((response: any) => {
        const expertSystemOptionsFromAPI: ExpertSystemOptions = response.reduce(
          (expertSystemOptions: ExpertSystemOptions, item: any) => {
            expertSystemOptions[item.expertPathName] = {
              ...item,
              associatedFiles: [...item.associatedFiles, 'Custom'],
              copilotPersona: item.persona,
            };
            return expertSystemOptions;
          },
          {} as ExpertSystemOptions
        );
        setExpertSystemOptions(expertSystemOptionsFromAPI);
        dispatch(updateExpertSystemOptions(expertSystemOptionsFromAPI as any));
      })
      .catch((error) => {
        console.error(
          'Error fetching expert verticals from API:',
          error.message
        );
      });
  }, [updateExpertSystemOptions]);

  const [filteredExpertSystemOptions, setFilteredExpertSystemOptions] =
    useState<ExpertSystemOptions>({});

  const DEMO_TYPES = {
    VERTICAL: 'Vertical',
    CUSTOMER: 'Customer',
  };

  /**
   *
   * @param expertSystemOptions -
   * @param filterForVertical -
   * @returns filtered expert system options
   * @example filterExpertSystemOptions(expertSystemOptions, true)
   */
  const filterExpertSystemOptions = (
    expertSystemOptions: ExpertSystemOptions,
    filterForVertical: boolean
  ) => {
    const result: Partial<ExpertSystemOptions> = {};
    for (const key in expertSystemOptions) {
      if (Object.prototype.hasOwnProperty.call(expertSystemOptions, key)) {
        const formatUsername = (email: string) => {
          const [firstName, lastName] = email.split('@')[0].split('.');
          return `${firstName.charAt(0).toUpperCase() + firstName.slice(1)} ${
            lastName.charAt(0).toUpperCase() + lastName.slice(1)
          }`;
        };
        const value = expertSystemOptions[key];
        const isOwner = value?.owner === formatUsername(loggedInUser);
        const isActiveAndAccessible =
          value?.status === 'Active' &&
          (value?.visibility === 'Public' || isOwner);

        if (
          filterForVertical
            ? value?.demoType === 'Vertical' && isActiveAndAccessible
            : value?.demoType === 'Custom' && isActiveAndAccessible
        ) {
          result[key] = value;
        }
      }
    }
    return result as ExpertSystemOptions;
  };

  useEffect(() => {
    setFilteredExpertSystemOptions(
      filterExpertSystemOptions(
        expertSystemOptions as ExpertSystemOptions,
        demoType === DEMO_TYPES.VERTICAL
      )
    );
  }, [demoType, expertSystemOptions]);

  const handleSaveClick = async ({
    index,
    keyName,
    value,
  }: {
    index: string;
    keyName: string;
    value: string;
  }) => {
    const channel: BroadcastChannel<any> = new BroadcastChannel(
      'simulator_channel'
    );
    await channel.postMessage({
      type: 'saveCopilotConfig',
      data: localConfiguration,
    });
    await channel.close();
  };

  const handleSaveIndexClick = async ({
    index,
    keyName,
    value,
  }: {
    index: string;
    keyName: string;
    value: string;
  }) => {
    const {
      expertCopilotURL,
      expertCopilotClientKey,
      expertCopilotClientSecret,
      kBAnswersPath,
      salesOffersPath,
      compliancePath,
      expertPathName,
      copilotPersona,
    } = expertSystemValues?.[index] || {};

    const channel: BroadcastChannel<any> = new BroadcastChannel(
      'simulator_channel'
    );
    await channel.postMessage({
      type: 'saveCopilotConfig',
      data: {
        ...localConfiguration,
        expertCopilotURL,
        expertCopilotClientKey: expertCopilotClientKey?.substring(0, 9),
        expertCopilotClientSecret: expertCopilotClientSecret?.substring(0, 9),
        kBAnswersPath,
        salesOffersPath,
        compliancePath,
        path: expertPathName,
        botPersona: copilotPersona ?? '',
        [keyName]: value,
      },
    });
    await channel.close();
  };

  const handleIndexInputChange = async (e: any, key: string) => {
    const value = e?.target?.value;
    let updatedConfig = { ...localConfiguration, [key]: value };

    switch (key) {
      case 'index':
        handleSaveIndexClick({
          index: value ?? '',
          keyName: key,
          value: value,
        });
        updatedConfig = {
          ...updatedConfig,
          botPersona: expertSystemOptions?.[value]?.copilotPersona,
        };
        break;
      case 'language':
        updatedConfig = {
          ...updatedConfig,
          path: 'custom',
          associatedFile: '',
          botPersona: '',
          demoType: '',
        };
        break;
      case 'demoType':
        updatedConfig = {
          ...updatedConfig,
          path: 'custom',
          associatedFile: '',
          botPersona: '',
        };
        break;
      default:
        break;
    }

    setLocalConfiguration(updatedConfig);
  };

  const expertSystemValues: ExpertSystemOptions =
    expertSystemOptions as ExpertSystemOptions;

  useEffect(() => {
    setLocalConfiguration(copilotConfiguration);
  }, [copilotConfiguration]);

  const associatedFiles =
    expertSystemValues?.[localConfiguration.path]?.associatedFiles;
  const configFileUpload = useRef<any>(null);

  /**
   * Function to get file info of attchment being uploaded
   * @example getConfigFileInfo()
   */
  const getConfigFileInfo = () => {
    // setProgress(0);
    const data = new FormData();
    data.append('file', configFileUpload.current.files);
    const attachmentCopy = [];
    for (const item of configFileUpload.current.files) {
      attachmentCopy.push({ name: item.name, progress: 0 });
    }
    getConfigFileContent();
    configFileUpload.current.value = '';
  };

  /**
   * Function to get file content of JSON file being uploaded
   * @example getConfigFileContent()
   */
  const getConfigFileContent = () => {
    const file = configFileUpload.current.files[0];
    const fr = new FileReader();
    fr.onload = receivedConfigText;
    fr.readAsText(file);
  };

  /**
   * Function to receive text file content of json file being uploaded
   * @example receivedConfigText()
   */
  const receivedConfigText = (e: any) => {
    const lines = e.target.result;
    const newConfig = JSON.parse(lines);
    const updatedConfigs: ExpertSystemOptions = {} as ExpertSystemOptions;
    newConfig.customConfig.forEach((config: any) => {
      const key = config.expertPathName ?? 'custom';
      updatedConfigs[key] = {
        expertSystem: config.expertSystem ?? 'Custom',
        expertPathName: config.expertPathName ?? 'custom',
        associatedFiles: [],
        expertCopilotURL: config.expertCopilotUrl ?? '',
        kBAnswersPath: config.kbAnswersPath ?? 'KnowledgeContent',
        salesOffersPath: config.salesOffersPath ?? 'SalesContent',
        compliancePath: config.compliancePath ?? 'ComplianceContent',
        expertCopilotClientKey: config.expertCopilotClientKey ?? '',
        expertCopilotClientSecret: config.expertCopilotClientSecret ?? '',
        copilotPersona: config.copilotPersona ?? '',
        status: config.status ?? '',
        demoType: config.demoType ?? '',
        visibility: config.visibility ?? '',
        owner: config.owner ?? '',
        description: config.description ?? '',
        lastUpdatedBy: config.lastUpdatedBy ?? '',
        lastUpdatedTime: config.lastUpdatedTime ?? '',
      };
    });
    const mergedConfigs = { ...expertSystemOptions, ...updatedConfigs };
    setExpertSystemOptions(mergedConfigs);
    dispatch(updateExpertSystemOptions(mergedConfigs as any));
  };

  const readAssociatedFileContent = (e: any) => {
    const fileName = e.target.value;
    axios({
      url: './../assets/' + fileName,
      method: 'GET',
      responseType: 'blob',
    })
      .then((response) => {
        const fr = new FileReader();
        fr.onload = receivedAssociatedFileText;
        fr.readAsText(response.data); // Pass the blob data to readAsText
      })
      .catch((error) => {
        console.error('Error fetching file:', error);
      });
    handleInputChange('customerChatReply', '');
  };

  const receivedAssociatedFileText = (e: any) => {
    if (isLiveCopilotEnabled) {
      const {
        dataFile: dataFileArr,
        audioFileName,
        customerFullName: customerName,
        agentName,
        interactions: previousInteractions,
        intents,
        customReplies,
        autopilotSummary,
        transferSummary,
        customerSentiment,
        confidence,
        emailId,
        emailSubject,
        receiverEmail,
        attachments,
      } = JSON.parse(e.target.result);
      const [firstName, lastName] = customerName.split(' ');
      const id = generateRandomId(agentName, customerName);
      const processedArray = processResultToArray(
        dataFileArr,
        selectedContact.media,
        agentName
      );
      const inputChanges = {
        customerChatReplyJsonData: processedArray,
        perviousInteractionJsonData: previousInteractions,
        intents,
        customReplies,
        customerSentiment,
        confidence,
        audioFileName,
        firstName,
        lastName,
        autopilotSummary,
        transferSummary,
        emailId,
        emailSubject,
        receiverEmail,
        attachments,
        channel:
          selectedContact?.channel === 'Email'
            ? DigitalChannelType.EMAIL
            : DigitalChannelType.CHAT,
        id,
      };
      if (selectedContact.media === 'Voice') {
        handleInputChange('messageType', '253-895-8956');
        handleInputChange('queueName', 'Cust. Service Request');
      }
      Object.entries(inputChanges).forEach(([key, value]) =>
        handleInputChange(key, value)
      );
      setToastMessage('File Saved');
      setShowToast(true);
    }
  };
  const supportedLanguages = [
    { code: 'en-US', label: 'English' },
    { code: 'pt-BR', label: 'Português' },
  ];

  return (
    <Grid className={classes.simulatorColumn}>
      <Paper elevation={3} className={classes.simulatorPaperWithFullheight}>
        <Card className={classes.heightInherit}>
          <CcfTypography
            className={classes.txtChatMsg}
            style={{ marginTop: '20px', marginLeft: '15px' }}
          >
            COPILOT DEMO SETTINGS
          </CcfTypography>
          <CardContent>
            <form
              className={classes.root + ' ' + classes.simulatorForm}
              noValidate
              autoComplete="off"
            >
              <FormControl
                fullWidth
                variant="outlined"
                className={classes.formControl}
                style={{
                  width: '100%',
                  marginBottom: '15px',
                }}
              >
                <InputLabel>Output Language</InputLabel>
                <Select
                  labelId=""
                  id=""
                  value={localConfiguration.language}
                  label="Output Language"
                  onChange={(e: any) => {
                    readAssociatedFileContent(e);
                    handleIndexInputChange(e, 'language');
                  }}
                >
                  {supportedLanguages?.map((lang, index) => {
                    return (
                      <MenuItem key={index} value={lang.code}>
                        {lang.label}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <FormControl
                fullWidth
                variant="outlined"
                className={classes.formControl}
                style={{
                  width: '100%',
                  marginBottom: '15px',
                }}
              >
                <InputLabel>Demo Type</InputLabel>
                <Select
                  labelId=""
                  id=""
                  value={localConfiguration.demoType}
                  label="Demo Type"
                  onChange={(e: any) => {
                    handleIndexInputChange(e, 'demoType');
                  }}
                >
                  <MenuItem value="Vertical">{DEMO_TYPES.VERTICAL}</MenuItem>
                  <MenuItem value="Customer">{DEMO_TYPES.CUSTOMER}</MenuItem>
                </Select>
              </FormControl>
              {demoType && (
                <FormControl
                  fullWidth
                  variant="outlined"
                  className={classes.formControl}
                  style={{
                    width: '100%',
                    marginBottom: '15px',
                  }}
                >
                  <InputLabel>Demo</InputLabel>
                  <Select
                    labelId=""
                    id=""
                    value={localConfiguration.path}
                    label="Demo"
                    onChange={(e: any) => {
                      handleIndexInputChange(e, 'index');
                      handleIndexInputChange(e, 'path');
                    }}
                  >
                    {Object.keys(
                      filteredExpertSystemOptions as ExpertSystemOptions
                    ).map((key) => (
                      <MenuItem key={key} value={key}>
                        {filteredExpertSystemOptions &&
                          filteredExpertSystemOptions[
                            key as keyof typeof filteredExpertSystemOptions
                          ].expertSystem}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              {localConfiguration.path !== 'custom' && (
                <FormControl
                  fullWidth
                  variant="outlined"
                  className={classes.formControl}
                  style={{
                    width: '100%',
                    marginBottom: '15px',
                  }}
                >
                  <InputLabel>Demo JSON</InputLabel>
                  <Select
                    labelId=""
                    id=""
                    value={localConfiguration.associatedFile}
                    label="Demo JSON"
                    onChange={(e: any) => {
                      readAssociatedFileContent(e);
                      handleIndexInputChange(e, 'associatedFile');
                    }}
                  >
                    {associatedFiles?.map((file: any, index: any) => {
                      return (
                        <MenuItem
                          key={index}
                          disabled={file.status === 'Inactive'}
                          value={`${file.name}.json`}
                        >
                          {file.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              )}
              {localConfiguration.path === 'custom' && (
                <div
                  className={classes.uploadFileInnerBox}
                  style={{ marginBottom: '10%' }}
                >
                  <input
                    type="file"
                    hidden
                    ref={configFileUpload}
                    multiple
                    onChange={(e) => {
                      getConfigFileInfo();
                    }}
                  />
                  <CcfSimulatorUploadIcon
                    onClick={() => {
                      configFileUpload.current.click();
                    }}
                  />
                  <CcfTypography className={classes.txtUploadTemplate}>
                    Load custom config
                  </CcfTypography>
                </div>
              )}
              <CcfTextField
                id="outlined-basic"
                className={classes.input}
                label="Copilot Persona"
                multiline
                rows={8}
                maxRows={21}
                placeholder="add copilot persona"
                variant="outlined"
                value={localConfiguration.botPersona}
                InputLabelProps={{ shrink: true }}
                onChange={(e: any) => {
                  handleIndexInputChange(e, 'botPersona');
                }}
              />
              {localConfiguration.path === 'custom' && (
                <>
                  <CcfTextField
                    id="outlined-basic"
                    className={classes.input}
                    label="Expert Key"
                    variant="outlined"
                    type="password"
                    defaultValue={
                      expertSystemValues?.[localConfiguration.path]
                        ?.expertCopilotClientKey
                    }
                    value={localConfiguration.expertCopilotClientKey}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e: any) => {
                      handleIndexInputChange(e, 'expertCopilotClientKey');
                    }}
                  />
                  <CcfTextField
                    id="outlined-basic"
                    className={classes.input}
                    label="Expert Secret"
                    variant="outlined"
                    type="password"
                    defaultValue={
                      expertSystemValues?.[localConfiguration.path]
                        ?.expertCopilotClientSecret
                    }
                    value={localConfiguration.expertCopilotClientSecret}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e: any) => {
                      handleIndexInputChange(e, 'expertCopilotClientSecret');
                    }}
                  />
                  <CcfTextField
                    id="outlined-basic"
                    className={classes.input}
                    label="Site"
                    variant="outlined"
                    defaultValue={
                      expertSystemValues?.[localConfiguration.path]
                        ?.expertCopilotURL
                    }
                    value={localConfiguration.expertCopilotURL}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e: any) => {
                      handleIndexInputChange(e, 'expertCopilotURL');
                    }}
                  />

                  <CcfTextField
                    id="outlined-basic"
                    className={classes.input}
                    label="Knowledge Path"
                    variant="outlined"
                    defaultValue={
                      expertSystemValues?.[localConfiguration.path]
                        ?.kBAnswersPath
                    }
                    value={localConfiguration.kBAnswersPath}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e: any) => {
                      handleIndexInputChange(e, 'kBAnswersPath');
                    }}
                  />
                  <CcfTextField
                    id="outlined-basic"
                    className={classes.input}
                    label="Offers Path"
                    variant="outlined"
                    defaultValue={
                      expertSystemValues?.[localConfiguration.path]
                        ?.salesOffersPath
                    }
                    value={localConfiguration.salesOffersPath}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e: any) => {
                      handleIndexInputChange(e, 'salesOffersPath');
                    }}
                  />
                  <CcfTextField
                    id="outlined-basic"
                    className={classes.input}
                    label="Compliance Path"
                    variant="outlined"
                    defaultValue={
                      expertSystemValues?.[localConfiguration.path]
                        ?.compliancePath
                    }
                    value={localConfiguration.compliancePath}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e: any) => {
                      handleIndexInputChange(e, 'compliancePath');
                    }}
                  />
                </>
              )}
            </form>
          </CardContent>
          <CardActions className={classes.simulatorSaveButton}>
            <Button
              variant="contained"
              color="primary"
              onClick={(e) => handleSaveClick(copilotConfiguration.path ?? '')}
              style={{ padding: '8px' }}
            >
              Apply
            </Button>
          </CardActions>
        </Card>
      </Paper>
    </Grid>
  );
}

/**
 *
 * @param props -
 * @example
 * @returns
 */
function CustomerChatData(props: {
  selectedContact: Contact;
  handleInputChange: any;
  broadCastCopilotData: any;
  isLiveCopilotEnabled: boolean;
  clearSimulatorClicked: boolean;
  setClearSimulatorClicked: any;
}) {
  const {
    selectedContact,
    handleInputChange,
    broadCastCopilotData,
    isLiveCopilotEnabled,
    clearSimulatorClicked,
    setClearSimulatorClicked,
  } = props;
  const [chatMessage, setChatMessage] = useState('');
  const fileUpload = useRef<any>(null);
  const dispatch = useDispatch();

  const [replyAttachmentList, setreplyAttachmentList] = useState(Array);

  useEffect(() => {
    if (clearSimulatorClicked) {
      setreplyAttachmentList([]);
      if (fileUpload?.current) {
        fileUpload.current.value = '';
      }
      setChatMessage('');
      setClearSimulatorClicked(false);
    }
  }, [clearSimulatorClicked]);

  /**
   * Function to handle Chat Message Input
   * @example - chatMessageHandler()
   */
  const chatMessageHandler = (e: any) => {
    setChatMessage(e.target.value);
  };

  /**
   * Function to handle Chat Message Input
   * @example - chatMessageHandler()
   */
  const handleSendReplyClick = (e: any) => {
    handleInputChange('customerChatReply', chatMessage);
    //handleButtonClick();
    //dispatch(updateCustomerChatJSONData(chatMessage));
  };

  /**
   * Function to get file info of attchment being uploaded
   * @example getFileInfo()
   */
  const getFileInfo = () => {
    // setProgress(0);
    const data = new FormData();
    data.append('file', fileUpload.current.files);
    const attachmentCopy = [];
    for (const item of fileUpload.current.files) {
      attachmentCopy.push({ name: item.name, progress: 0 });
    }
    setreplyAttachmentList([...replyAttachmentList, ...attachmentCopy]);
    setreplyAttachmentList((state) => {
      return state;
    });
    getFileContent();
    handleInputChange('customerChatReply', '');

    fileUpload.current.value = '';
  };

  /**
   * Function to get file content of JSON file being uploaded
   * @example getFileContent()
   */
  const getFileContent = () => {
    const file = fileUpload.current.files[0];
    const fr = new FileReader();
    fr.onload = receivedText;
    fr.readAsText(file);
  };

  /**
   * Function to receive text file content of json file being uploaded
   * @example receivedText()
   */
  const receivedText = (e: any) => {
    if (!isLiveCopilotEnabled) {
      const lines = e.target.result;
      let newArr;
      try {
        newArr = JSON.parse(lines);
      } catch (error) {
        console.error("Error parsing JSON:", error);
        newArr = {};
      }
      handleInputChange('customerChatReplyJsonData', newArr);
      const conversationData =
        selectedContact?.media === 'Voice'
          ? newArr.copilotAgentAndCustomerVoiceData
          : selectedContact?.media === MediaType.DIGITAL &&
            selectedContact?.channel === 'Chat'
          ? newArr.copilotAgentAndCustomerChatData
          : newArr.copilotAgentAndCustomerEmailData;
      const perviousInteractions = newArr.journeyHistory;
      const realTimeSummary = newArr.rtSummary;
      //const intents = newArr.copilotAgentAndCustomerChatData.intents;
      //const customReplies = newArr.customReplies;
      const autopilotSummary = newArr.autopilotSummary;
      const transferSummary = newArr.agentTransferSummary;
      const botTranscriptFile = newArr.botTranscriptData;
      const finalAutoSummary = newArr.finalAutoSummary;
      handleInputChange('customerChatReplyJsonData', conversationData);
      handleInputChange('perviousInteractionJsonData', perviousInteractions);
      handleInputChange('rtSummary', realTimeSummary);
      //handleInputChange('intents', intents);
      //handleInputChange('customReplies', customReplies);
      handleInputChange('autopilotSummary', autopilotSummary);
      handleInputChange('transferSummary', transferSummary);
      handleInputChange('botTranscriptData', botTranscriptFile);
      handleInputChange('autoSummaryText', finalAutoSummary);
      if (botTranscriptFile) {
        handleInputChange('botTranscript', true);
      }
    }
    if (isLiveCopilotEnabled) {
      const lines = e.target.result;
      const newArr = JSON.parse(lines);
      const dataFileArr = newArr.dataFile;
      const audioFileName = newArr.audioFileName;
      const customerName = newArr.customerFullName;
      const agentName = newArr.agentName;
      const perviousInteractions = newArr.interactions;
      const intents = newArr.intents;
      const customReplies = newArr.customReplies;
      const autopilotSummary = newArr.autopilotSummary;
      const transferSummary = newArr.transferSummary;
      const customerSentiment = newArr.customerSentiment;
      const confidence = newArr.confidence;
      const id = generateRandomId(agentName, customerName);
      const processedArray = processResultToArray(
        dataFileArr,
        selectedContact.media,
        agentName
      );
      const emailId = newArr.emailId;
      const emailSubject = newArr.emailSubject;
      const receiverEmail = newArr.receiverEmail;
      const attachments = newArr.attachments;

      handleInputChange('customerChatReplyJsonData', processedArray);
      handleInputChange('perviousInteractionJsonData', perviousInteractions);
      handleInputChange('intents', intents);
      handleInputChange('customReplies', customReplies);
      handleInputChange('customerSentiment', customerSentiment);
      handleInputChange('confidence', confidence);
      handleInputChange('audioFileName', audioFileName);
      handleInputChange('customerName', customerName);
      handleInputChange('firstName', customerName.split(' ')[0]);
      handleInputChange('lastName', customerName.split(' ')[1]);
      handleInputChange('autopilotSummary', autopilotSummary);
      handleInputChange('transferSummary', transferSummary);
      handleInputChange('emailId', emailId);
      handleInputChange('emailSubject', emailSubject);
      handleInputChange('receiverEmail', receiverEmail);
      handleInputChange('attachments', attachments);
      selectedContact?.channel === 'Email'
        ? handleInputChange('channel', DigitalChannelType.EMAIL)
        : handleInputChange('channel', DigitalChannelType.CHAT);
      handleInputChange('id', id);
    }
  };

  /**
   * function  to remove attachment
   * @param param0 - param
   * @example attachmentRemoveHandler()
   * @returns
   */
  function attachmentRemoveHandler(attachmentItem: any) {
    const updatedAttachmentList = replyAttachmentList.filter(
      (attach: any) => attach.name !== attachmentItem
    );
    setreplyAttachmentList(updatedAttachmentList);
    if (fileUpload?.current) {
      fileUpload.current.value = '';
    }
  }

  /**
   * function  for Attachment Progress bar
   * @param param0 - progressValue
   * @param param1 - attachmentId
   * @example progressCallback(30,1)
   * @returns
   */
  function progressCallback(progressValue: any, attachmentId: number) {
    setreplyAttachmentList(
      replyAttachmentList.map((attachment: any, index: number) => {
        if (index === attachmentId) {
          // if(progressValue === 100) {
          //   const jsonChatData = JSON.parse(attachment);
          //   dispatch(updateCustomerChatJSONData(jsonChatData));
          // }
          return { ...attachment, progress: progressValue };
        }
        return attachment;
      })
    );
    setreplyAttachmentList((state) => {
      return state;
    });
  }

  /**
   * Function to download JSON file template
   * @example - downloadChatJsonFile()
   */
  const downloadChatJsonFile = () => {
    const fileName =
      selectedContact.channel === 'Chat' &&
      selectedContact.copilotAssist === 'Yes' &&
      selectedContact.copilotSource === 'JSON'
        ? 'CopilotChatData.json'
        : selectedContact.channel === 'Chat' &&
          selectedContact.copilotAssist === 'Yes' &&
          selectedContact.copilotSource === 'Live LLM'
        ? 'oneAppliance_chat.json'
        : selectedContact?.media === MediaType.VOICE &&
          selectedContact.copilotAssist === 'Yes' &&
          selectedContact.copilotSource === 'JSON'
        ? 'CopilotVoiceData.json'
        : selectedContact?.media === MediaType.VOICE &&
          selectedContact.copilotAssist === 'Yes' &&
          selectedContact.copilotSource === 'Live LLM'
        ? 'onetelecomvoice.json'
        : 'ChatData.json';
    axios({
      url: './../assets/' + fileName,
      method: 'GET',
      responseType: 'blob',
    })
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  return (
    // <Grid className={classes.simulatorColumn}>
    //   <Paper elevation={3} className={classes.simulatorPaper}>
    <Card className={classes.heightInherit}>
      <CardContent>
        <form
          className={classes.root + ' ' + classes.simulatorForm}
          noValidate
          autoComplete="off"
        >
          <CcfTypography className={classes.txtChatMsg}>
            CUSTOMER CHAT SIMULATOR
          </CcfTypography>
          <CcfTypography className={classes.headingSubText}>
            Type a test chat below for the simulator. For bulk chats, use the
            template.
          </CcfTypography>
          <Divider
            style={{ background: '#F0F0F0', height: '1px', width: '100%' }}
          />
          <CcfBox className={classes.mainDivBlock}>
            <CcfBox
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <CcfChatIcon
                style={{ height: '20px', width: '20px', marginTop: '6px' }}
              />
              <CcfTypography className={classes.txtChat}>Chat</CcfTypography>
            </CcfBox>
            <textarea
              rows={7}
              id={`sm_copilot_customerChat_textArea`}
              cols={21}
              disabled={replyAttachmentList?.length > 0}
              placeholder="Type a message here"
              className={classes.textAreaInput}
              value={chatMessage}
              onChange={(event) => chatMessageHandler(event)}
            />
            <CcfBox
              className={
                replyAttachmentList?.length > 0
                  ? classes.uploadedFileBox
                  : classes.uploadFileBox
              }
              style={{ cursor: chatMessage ? 'not-allowed' : 'pointer' }}
            >
              {replyAttachmentList?.length === 0 && (
                <div className={classes.uploadFileInnerBox}>
                  <input
                    type="file"
                    id={`sm_copilot_customerChat_uploadTemplate`}
                    hidden
                    ref={fileUpload}
                    multiple
                    onChange={getFileInfo}
                    disabled={chatMessage.length > 0}
                  />
                  <CcfSimulatorUploadIcon
                    onClick={() => {
                      fileUpload.current.click();
                    }}
                  />
                  <CcfTypography className={classes.txtUploadTemplate}>
                    Upload template
                  </CcfTypography>
                </div>
              )}
              {replyAttachmentList.length > 0 && (
                <TransitionGroup>
                  <CcfTypography className={classes.txtFile}>
                    File:
                  </CcfTypography>
                  {replyAttachmentList.map(
                    (attachmentItem: any, index: number) => {
                      return (
                        <Slide key={index} direction={'left'} timeout={500}>
                          <div
                            className={classes.attachmentBox}
                            style={{
                              width: '100%',
                            }}
                            key={index}
                          >
                            <CcfTypography
                              className={
                                attachmentItem.progress === 100
                                  ? classes.fileNameUploaded
                                  : classes.fileNameInBlack
                              }
                              style={{
                                width: '100%',
                              }}
                            >
                              {attachmentItem.name}
                            </CcfTypography>
                            <CcfEmailProgressBar
                              attachmentId={index}
                              progressCallback={progressCallback}
                            />
                            <CcfCloseIcon
                              className={classes.attachmentCloseIcon}
                              onClick={() => {
                                attachmentRemoveHandler(attachmentItem.name);
                              }}
                            />
                          </div>
                        </Slide>
                      );
                    }
                  )}
                </TransitionGroup>
              )}
            </CcfBox>
            <CcfBox className={classes.clickHereStatement}>
              <span
                style={{
                  color: '#007AB8',
                  textDecorationLine: 'underline',
                }}
                onClick={downloadChatJsonFile}
                id={`sm_copilot_customerChat_downloadTemplate`}
              >
                Click here
              </span>
              &nbsp; to download template to create bulk chats.
            </CcfBox>
            <CcfBox className={classes.btnBox}>
              <CcfButton
                className={`${classes.btn} ${classes.CancelButton}`}
                id={`sm_copilot_customerChat_cancel_button`}
              >
                <CcfTypography
                  className={`${classes.btnText} ${classes.txtCancel}`}
                >
                  Cancel
                </CcfTypography>
              </CcfButton>
              <CcfButton
                primary
                className={`${classes.btn} ${classes.saveButton}`}
                disabled={!chatMessage}
                id={`sm_copilot_customerChat_send_button`}
                onClick={(e) => {
                  handleSendReplyClick(e);
                  if (isLiveCopilotEnabled) {
                    setTimeout(() => {
                      broadCastCopilotData(chatMessage);
                    });
                  }
                }}
              >
                <CcfTypography
                  className={`${classes.btnText} ${
                    chatMessage ? classes.txtSave : classes.txtSaveDisabled
                  }`}
                >
                  Send
                </CcfTypography>
              </CcfButton>
            </CcfBox>
          </CcfBox>
        </form>
      </CardContent>
    </Card>
    //   </Paper>
    // </Grid>
  );
}

/**
 * To show the dropdown element which takes the below props
 * @param props - it will have currentValue, field, label for the dropdown, dropdown options and a onchange handler
 * @returns
 */
export function DropDown(props: {
  customerHistoryId?: any;
  isFromContactHistory?: boolean;
  isFromInteractionHistory?: boolean;
  currentValue: string;
  field: string;
  label: string;
  options: string[];
  handleInputChange?: (field: string, value: string) => any;
  handleInputChangeForHistory?: (
    id: any,
    field: string,
    value: string,
    isFromContactHistory?: boolean
  ) => void;
  handleInputChangeForInteractionHistory?: (
    id: any,
    field: string,
    value: string
  ) => void;
  id?: any;
  stackName?: any;
  selectInputStyle?: any;
  selectRootStyle?: any;
}) {
  let { currentValue } = props;
  const {
    customerHistoryId,
    isFromContactHistory,
    isFromInteractionHistory,
    handleInputChangeForInteractionHistory,
    field,
    label,
    options,
    handleInputChange,
    handleInputChangeForHistory,
    id,
    stackName,
    selectInputStyle,
    selectRootStyle,
  } = props;
  if (!currentValue) currentValue = options[0];

  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
      size={
        isFromContactHistory || isFromInteractionHistory ? 'small' : undefined
      }
      style={{
        width:
          isFromContactHistory || isFromInteractionHistory ? '100%' : undefined,
        marginBottom:
          isFromContactHistory || isFromInteractionHistory ? '15px' : undefined,
      }}
      id={`${id}` || 'demo-simple-select'}
    >
      <InputLabel id="demo-simple-select-outlined-label">{label}</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        variant="outlined"
        sx={{
          '&.MuiOutlinedInput-root': selectInputStyle,
          '& .MuiSelect-root': selectRootStyle,
          '&& fieldset': {
            border: '1px solid #c4c4c4',
          },
        }}
        IconComponent={() => (
          <CcfUpArrowIcon className={classes.arrowIconForDropdown} />
        )}
        value={currentValue}
        onChange={(event: any) => {
          isFromContactHistory
            ? handleInputChangeForHistory?.(
                customerHistoryId,
                field,
                event.target.value as string,
                isFromContactHistory
              )
            : isFromInteractionHistory
            ? handleInputChangeForInteractionHistory?.(
                customerHistoryId,
                field,
                event.target.value as string
              )
            : handleInputChange?.(field, event.target.value as string);
        }}
        className={classes.input}
        label={label}
      >
        {options.map((option: string, index: number) => {
          return (
            <MenuItem
              value={option}
              key={index}
              id={`sm_${stackName}_${option}`}
            >
              {option}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

/**
 * To show the contact detail for the selected contact from the contact list card. This will also let user to edit the values for the contact detail
 * @param props - it will take selected contact detail, and onchange hadnler
 * @returns
 */
function CopilotConfig(props: {
  selectedContact: Contact;
  handleButtonClick: () => void;
  buttonText: string;
}) {
  const { selectedContact, handleButtonClick, buttonText } = props;
  const theme = useTheme();
  const simStyles = simulatorStyles(theme);
  const copilotConfiguration: any = useSelector(getCopilotConfig);
  const dispatch = useDispatch();

  const [localConfiguration, setLocalConfiguration] =
    useState(copilotConfiguration);

  const handleInputChange = (e: any, key: string) => {
    setLocalConfiguration((prevConfig: any) => ({
      ...prevConfig,
      [key]: e.target.value,
    }));
  };

  const handleSwitchChange = (e: any, key: string) => {
    setLocalConfiguration((prevConfig: any) => ({
      ...prevConfig,
      [key]: e.target.checked,
    }));
  };

  const handleSaveClick = async () => {
    const channel: BroadcastChannel<any> = new BroadcastChannel(
      'simulator_channel'
    );
    await channel.postMessage({
      type: 'saveCopilotConfig',
      data: localConfiguration,
    });
    await channel.close();
    //saveCopilotConfig(localConfiguration,dispatch);
  };

  return (
    <Grid className={classes.simulatorColumn}>
      <Paper elevation={3} className={classes.simulatorPaperWithFullheight}>
        <Card className={classes.heightInherit}>
          <CcfTypography
            className={classes.txtChatMsg}
            style={{ marginTop: '20px', marginLeft: '15px' }}
          >
            COPILOT PROFILE SETTINGS
          </CcfTypography>
          <CardContent>
            <form
              className={classes.root + ' ' + classes.simulatorForm}
              noValidate
              autoComplete="off"
            >
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Response Tone
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={localConfiguration.generativeResponseTone}
                  label="Response Tone"
                  onChange={(e: any) => {
                    handleInputChange(e, 'generativeResponseTone');
                  }}
                >
                  <MenuItem value={'Formal'}>Formal</MenuItem>
                  <MenuItem value={'Casual'}>Casual</MenuItem>
                  <MenuItem value={'Confident'}>Confident</MenuItem>
                  <MenuItem value={'Empathetic'}>Empathetic</MenuItem>
                  <MenuItem value={'Formal'}>Formal</MenuItem>
                  <MenuItem value={'Instructive'}>Instructive</MenuItem>
                </Select>
              </FormControl>
              <FormControlLabel
                label="Sentiment"
                labelPlacement="start"
                style={simStyles.simLabelStyles}
                control={
                  <Switch
                    name="Sentiment"
                    color="primary"
                    checked={localConfiguration.enableSentiment}
                    sx={{
                      ' .MuiFormControlLabel-label': {
                        width: 165,
                      },
                    }}
                    style={{ marginLeft: 0 }}
                    onChange={(e) => handleSwitchChange(e, 'enableSentiment')}
                  />
                }
              />
              <CcfTextField
                id="outlined-basic"
                className={classes.input}
                label="Response Length"
                variant="outlined"
                value={localConfiguration.sentimentResponseLength}
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: 5, min: 1 }}
                onChange={(e: any) =>
                  handleInputChange(e, 'sentimentResponseLength')
                }
                disabled={!localConfiguration.enableSentiment}
              />
              <FormControlLabel
                label="Real-time summary"
                labelPlacement="start"
                style={simStyles.simLabelStyles}
                control={
                  <Switch
                    name="RealtimeSummary"
                    color="primary"
                    checked={localConfiguration.realTimeSummary}
                    onChange={(e) => handleSwitchChange(e, 'realTimeSummary')}
                  />
                }
              />
              <CcfTextField
                id="outlined-basic"
                className={classes.input}
                label="Response Length"
                variant="outlined"
                value={localConfiguration.realTimeSummaryResponseLength}
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: 5, min: 1 }}
                onChange={(e: any) =>
                  handleInputChange(e, 'realTimeSummaryResponseLength')
                }
                disabled={!localConfiguration.realTimeSummary}
              />
              <FormControlLabel
                label="Final Summary"
                labelPlacement="start"
                style={simStyles.simLabelStyles}
                control={
                  <Switch
                    name="finalSummary"
                    color="primary"
                    checked={localConfiguration.finalSummary}
                    onChange={(e) => handleSwitchChange(e, 'finalSummary')}
                  />
                }
              />
              <CcfTextField
                id="outlined-basic"
                className={classes.input}
                label="Response Length"
                variant="outlined"
                value={localConfiguration.finalSummaryResponseLength}
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: 5, min: 1 }}
                onChange={(e: any) =>
                  handleInputChange(e, 'finalSummaryResponseLength')
                }
                disabled={!localConfiguration.finalSummary}
              />
              <FormControlLabel
                label="Knowledge Base Articles"
                labelPlacement="start"
                style={simStyles.simLabelStyles}
                control={
                  <Switch
                    name="knowledgeBaseArticles"
                    color="primary"
                    checked={localConfiguration.knowledgeBaseArticles}
                    onChange={(e) =>
                      handleSwitchChange(e, 'knowledgeBaseArticles')
                    }
                  />
                }
              />
              <CcfTextField
                id="outlined-basic"
                className={classes.input}
                label="Threshold"
                variant="outlined"
                value={localConfiguration.threshold}
                type="number"
                onChange={(e: any) => handleInputChange(e, 'threshold')}
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: 1, min: 0, step: 0.05 }}
              />
              <CcfTextField
                id="outlined-basic"
                className={classes.input}
                label="Response Length"
                variant="outlined"
                value={localConfiguration.knowledgeBaseArticlesResponseLength}
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: 5, min: 1 }}
                onChange={(e: any) =>
                  handleInputChange(e, 'knowledgeBaseArticlesResponseLength')
                }
                disabled={!localConfiguration.knowledgeBaseArticles}
              />
              <FormControlLabel
                label="Web links"
                labelPlacement="start"
                style={simStyles.simLabelStyles}
                control={
                  <Switch
                    name="webLinks"
                    color="primary"
                    checked={localConfiguration.knowledgeBaseWebLinks}
                    onChange={(e) =>
                      handleSwitchChange(e, 'knowledgeBaseWebLinks')
                    }
                  />
                }
              />
              <CcfTextField
                id="outlined-basic"
                className={classes.input}
                label="Maximum"
                variant="outlined"
                value={localConfiguration.knowledgeBaseMaximumWebLinks}
                type="number"
                onChange={(e: any) =>
                  handleInputChange(e, 'knowledgeBaseMaximumWebLinks')
                }
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: 5, min: 1 }}
                disabled={!localConfiguration.knowledgeBaseWebLinks}
              />
              <FormControlLabel
                label="Images"
                labelPlacement="start"
                style={simStyles.simLabelStyles}
                control={
                  <Switch
                    name="images"
                    color="primary"
                    checked={localConfiguration.knowledgeBaseImages}
                    onChange={(e) =>
                      handleSwitchChange(e, 'knowledgeBaseImages')
                    }
                  />
                }
              />
              <CcfTextField
                id="outlined-basic"
                className={classes.input}
                label="Maximum"
                variant="outlined"
                type="number"
                value={localConfiguration.knowledgeBaseMaximumImages}
                onChange={(e: any) =>
                  handleInputChange(e, 'knowledgeBaseMaximumImages')
                }
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: 5, min: 1 }}
                disabled={!localConfiguration.knowledgeBaseImages}
              />
              <FormControlLabel
                label="Process Steps"
                labelPlacement="start"
                style={simStyles.simLabelStyles}
                control={
                  <Switch
                    name="processSteps"
                    color="primary"
                    checked={localConfiguration.knowledgeBaseProcessSteps}
                    onChange={(e) =>
                      handleSwitchChange(e, 'knowledgeBaseProcessSteps')
                    }
                  />
                }
              />
              <CcfTextField
                id="outlined-basic"
                className={classes.input}
                label="Maximum"
                variant="outlined"
                value={localConfiguration.knowledgeBaseMaximumSteps}
                type="number"
                onChange={(e: any) =>
                  handleInputChange(e, 'knowledgeBaseMaximumSteps')
                }
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: 10, min: 1 }}
                disabled={!localConfiguration.knowledgeBaseProcessSteps}
              />

              <FormControlLabel
                label="Sales Offers"
                labelPlacement="start"
                style={simStyles.simLabelStyles}
                control={
                  <Switch
                    name="salesOffers"
                    color="primary"
                    checked={localConfiguration.salesOffers}
                    sx={{
                      ' .MuiFormControlLabel-label': {
                        width: 165,
                      },
                    }}
                    style={{ marginLeft: 0 }}
                    onChange={(e) => handleSwitchChange(e, 'salesOffers')}
                  />
                }
              />
              <CcfTextField
                id="outlined-basic"
                className={classes.input}
                label="Sales Threshold"
                variant="outlined"
                value={localConfiguration.threshold_sales}
                type="number"
                onChange={(e: any) => handleInputChange(e, 'threshold_sales')}
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: 1, min: 0, step: 0.05 }}
              />
              <FormControlLabel
                label="Compliance"
                labelPlacement="start"
                style={simStyles.simLabelStyles}
                control={
                  <Switch
                    name="compliance"
                    color="primary"
                    checked={localConfiguration.compliance}
                    sx={{
                      ' .MuiFormControlLabel-label': {
                        width: 165,
                      },
                    }}
                    style={{ marginLeft: 0 }}
                    onChange={(e) => handleSwitchChange(e, 'compliance')}
                  />
                }
              />
              <CcfTextField
                id="outlined-basic"
                className={classes.input}
                label="Compliance Threshold"
                variant="outlined"
                value={localConfiguration.threshold_compliance}
                type="number"
                onChange={(e: any) =>
                  handleInputChange(e, 'threshold_compliance')
                }
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: 1, min: 0, step: 0.05 }}
              />
              <FormControlLabel
                label="Back-and-forth Live Convo"
                labelPlacement="start"
                style={simStyles.simLabelStyles}
                control={
                  <Switch
                    name="backAndForthLiveConvo"
                    color="primary"
                    checked={localConfiguration.backAndForthLiveConvo}
                    onChange={(e) =>
                      handleSwitchChange(e, 'backAndForthLiveConvo')
                    }
                  />
                }
              />
              <CcfTextField
                id="outlined-basic"
                className={classes.input}
                label="Maximum"
                variant="outlined"
                type="number"
                value={localConfiguration.backAndForthLiveConvoLength}
                onChange={(e: any) =>
                  handleInputChange(e, 'backAndForthLiveConvoLength')
                }
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: 10, min: 2 }}
                disabled={!localConfiguration.backAndForthLiveConvo}
              />
            </form>
          </CardContent>
          <CardActions className={classes.simulatorSaveButton}>
            {/* <Button
              size="large"
              variant="contained"
              color="primary"
              onClick={handleButtonClick}
            >
              {buttonText}
            </Button> */}
            <Button
              size="large"
              variant="contained"
              color="primary"
              onClick={handleSaveClick}
              disabled={false}
            >
              Apply
            </Button>
          </CardActions>
        </Card>
      </Paper>
    </Grid>
  );
}
